// Custom Product Gallery Functionality
(function () {
  'use strict';

  window.mtProductHydrateVideoElement = function (video) {
    if (!video || video.getAttribute('data-hydrated') === 'true') {
      return video;
    }

    const sourcesJson = video.getAttribute('data-video-sources');
    if (!sourcesJson) return video;

    let sources;
    try {
      sources = JSON.parse(sourcesJson);
    } catch (error) {
      return video;
    }

    if (!Array.isArray(sources) || !sources.length) {
      return video;
    }

    const progressiveSources = sources.filter(function (source) {
      if (!source || !source.url) return false;
      const mimeType = (source.mime_type || '').toLowerCase();
      const format = (source.format || '').toLowerCase();
      return mimeType.indexOf('mpegurl') === -1 && format !== 'm3u8';
    });

    const preferredSources = progressiveSources.length ? progressiveSources : sources;

    preferredSources.forEach(function (source) {
      if (!source || !source.url) return;

      const sourceElement = document.createElement('source');
      sourceElement.src = source.url;

      if (source.mime_type) {
        sourceElement.type = source.mime_type;
      }

      video.appendChild(sourceElement);
    });

    video.setAttribute('data-hydrated', 'true');
    return video;
  };

  function isElementVisibleForVideoLoad(element) {
    if (!element) return false;

    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  window.mtProductPrepareVideoElement = function (video, options) {
    if (!video) return;

    const config = options || {};
    const container = config.container || video;

    if (!config.force && !isElementVisibleForVideoLoad(container)) {
      return;
    }

    const wasHydrated = video.getAttribute('data-hydrated') === 'true';
    window.mtProductHydrateVideoElement(video);

    if (video.getAttribute('data-hydrated') === 'true' && (!wasHydrated || !video.currentSrc)) {
      video.preload = 'auto';
      video.load();
    }
  };

  window.mtProductRequestVideoPlayback = function (video, options) {
    if (!video) return;

    window.mtProductPrepareVideoElement(video, Object.assign({ force: true }, options || {}));

    const playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        if (video.readyState >= 2) {
          return;
        }

        video.addEventListener('canplay', function retryPlayback() {
          const retryPromise = video.play();
          if (retryPromise && typeof retryPromise.catch === 'function') {
            retryPromise.catch(function () { });
          }
        }, { once: true });
      });
    }
  };

  // Initialize gallery when DOM is ready
  document.addEventListener('DOMContentLoaded', function () {
    initCustomGallery();
  });

  function initCustomGallery() {
    const galleryWrappers = document.querySelectorAll('.mt-custom-product-gallery-wrapper');

    galleryWrappers.forEach(function (wrapper) {
      const modal = wrapper.querySelector('.mt-gallery-modal');
      const galleryBtn = wrapper.querySelector('.mt-main-product-gallery-btn');
      const closeButton = wrapper.querySelector('.mt-gallery-modal-close');
      const prevButton = wrapper.querySelector('.mt-gallery-modal-prev');
      const nextButton = wrapper.querySelector('.mt-gallery-modal-next');
      const slider = wrapper.querySelector('.mt-gallery-modal-slider');
      const slides = wrapper.querySelectorAll('.mt-gallery-modal-slide');
      const dots = wrapper.querySelectorAll('.mt-gallery-modal-dot');
      const thumbnailItems = wrapper.querySelectorAll('.mt-gallery-thumbnail-item');
      const currentCounter = wrapper.querySelector('.mt-gallery-modal-current');
      const totalCounter = wrapper.querySelector('.mt-gallery-modal-total');

      if (!modal || !slides.length) return;

      // Store original position of wrapper
      const originalPosition = window.getComputedStyle(wrapper).position;

      let currentSlide = 0;
      const totalSlides = slides.length;
      let isScrolling = false;

      // Update counter
      if (totalCounter) {
        totalCounter.textContent = totalSlides;
      }

      // Show slide function
      function showSlide(index, scrollToSlide = true) {
        if (index < 0 || index >= totalSlides) return;

        // Remove active class from all slides and dots
        slides.forEach(function (slide) {
          slide.classList.remove('active');
        });

        dots.forEach(function (dot) {
          dot.classList.remove('active');
        });

        // Add active class to current slide and dot
        if (slides[index]) {
          slides[index].classList.add('active');
          window.mtProductPrepareVideoElement(slides[index].querySelector('video'), { container: modal });
        }

        if (dots[index]) {
          dots[index].classList.add('active');
        }

        // Update counter
        if (currentCounter) {
          currentCounter.textContent = index + 1;
        }

        // Scroll to slide
        if (scrollToSlide && slider && slides[index]) {
          isScrolling = true;
          slides[index].scrollIntoView({ behavior: 'smooth', block: 'start' });
          setTimeout(function () {
            isScrolling = false;
          }, 500);
        }

        currentSlide = index;
      }

      // Next slide
      function nextSlide() {
        const next = (currentSlide + 1) % totalSlides;
        showSlide(next);
      }

      // Previous slide
      function prevSlide() {
        const prev = (currentSlide - 1 + totalSlides) % totalSlides;
        showSlide(prev);
      }

      // Handle scroll event to update active slide
      function handleScroll() {
        if (isScrolling || !slider) return;

        const sliderRect = slider.getBoundingClientRect();
        const sliderTop = sliderRect.top;
        const sliderHeight = slider.clientHeight;
        const sliderCenter = sliderTop + sliderHeight / 2;

        let closestIndex = 0;
        let closestDistance = Infinity;

        // Find the slide closest to the center of the viewport
        slides.forEach(function (slide, index) {
          const slideRect = slide.getBoundingClientRect();
          const slideCenter = slideRect.top + slideRect.height / 2;
          const distance = Math.abs(slideCenter - sliderCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        if (closestIndex !== currentSlide && closestIndex >= 0 && closestIndex < totalSlides) {
          currentSlide = closestIndex;

          // Update active classes without scrolling
          slides.forEach(function (slide, index) {
            slide.classList.toggle('active', index === closestIndex);
          });

          dots.forEach(function (dot, index) {
            dot.classList.toggle('active', index === closestIndex);
          });

          // Update counter
          if (currentCounter) {
            currentCounter.textContent = closestIndex + 1;
          }

          window.mtProductPrepareVideoElement(slides[closestIndex].querySelector('video'), { container: modal });
        }
      }

      // Open modal
      function openModal(index) {
        // Change wrapper position to relative when modal opens
        wrapper.style.position = 'relative';

        // First make the modal visible
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
        document.body.classList.add('mt-gallery-modal-open');

        // Lower z-index of header and other elements that might overlap
        const header = document.querySelector('.mt-header');
        if (header) {
          header.style.zIndex = '1';
        }

        // Lower z-index of Poptin and other popups
        const popups = document.querySelectorAll('[class*="poptin"], [id*="poptin"], [class*="Poptin"], [id*="Poptin"]');
        popups.forEach(function (popup) {
          popup.style.zIndex = '1';
        });

        // Then show the slide after a small delay to ensure DOM is updated
        setTimeout(function () {
          if (index !== undefined) {
            showSlide(index);
          } else {
            showSlide(0);
          }
        }, 50);
      }

      // Close modal
      function closeModal() {
        modal.classList.remove('active');
        document.body.style.overflow = '';
        document.body.classList.remove('mt-gallery-modal-open');

        // Restore wrapper position to sticky when modal closes
        wrapper.style.position = 'sticky';

        // Restore z-index of header
        const header = document.querySelector('.mt-header');
        if (header) {
          header.style.zIndex = '';
        }

        // Restore z-index of Poptin and other popups
        const popups = document.querySelectorAll('[class*="poptin"], [id*="poptin"], [class*="Poptin"], [id*="Poptin"]');
        popups.forEach(function (popup) {
          popup.style.zIndex = '';
        });
      }

      // Get current image index from main product or thumbnail
      function getCurrentImageIndex() {
        // Try to get from active thumbnail
        const activeThumbnail = wrapper.querySelector('.mt-gallery-thumbnail-item.active');
        if (activeThumbnail) {
          const mediaIndex = activeThumbnail.getAttribute('data-media-index');
          const imageIndex = activeThumbnail.getAttribute('data-image-index');
          return parseInt(mediaIndex || imageIndex, 10);
        }
        // Fallback to first image
        return 0;
      }

      // Event listeners - Gallery button (must be before other listeners)
      if (galleryBtn) {
        galleryBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          const currentIndex = getCurrentImageIndex();
          openModal(currentIndex);
          return false;
        }, true); // Use capture phase to ensure it fires early
      }

      if (closeButton) {
        closeButton.addEventListener('click', closeModal);
      }

      if (prevButton) {
        prevButton.addEventListener('click', prevSlide);
      }

      if (nextButton) {
        nextButton.addEventListener('click', nextSlide);
      }

      // Dot navigation click handlers
      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          showSlide(index);
        });
      });

      // Scroll event listener for slider
      if (slider) {
        slider.addEventListener('scroll', handleScroll, { passive: true });
      }

      // Thumbnail click is handled by thumbnail gallery function

      // Close modal on overlay click
      const overlay = modal.querySelector('.mt-gallery-modal-overlay');
      if (overlay) {
        overlay.addEventListener('click', closeModal);
      }

      // Keyboard navigation
      document.addEventListener('keydown', function (e) {
        if (!modal.classList.contains('active')) return;

        if (e.key === 'Escape') {
          closeModal();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          prevSlide();
        } else if (e.key === 'ArrowDown') {
          e.preventDefault();
          nextSlide();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          prevSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          nextSlide();
        }
      });

      // Touch/swipe support for mobile (disabled - using native scroll instead)
      // The native scroll handles touch gestures automatically

      // Auto-play functionality (optional - can be enabled if needed)
      let autoPlayInterval = null;

      function startAutoPlay() {
        if (autoPlayInterval) return;
        autoPlayInterval = setInterval(function () {
          if (modal.classList.contains('active')) {
            nextSlide();
          }
        }, 5000); // Change slide every 5 seconds
      }

      function stopAutoPlay() {
        if (autoPlayInterval) {
          clearInterval(autoPlayInterval);
          autoPlayInterval = null;
        }
      }

      // Pause auto-play on hover
      modal.addEventListener('mouseenter', stopAutoPlay);
      modal.addEventListener('mouseleave', function () {
        if (modal.classList.contains('active')) {
          // startAutoPlay(); // Uncomment to enable auto-play
        }
      });
    });
  }

  // Video play/pause functionality
  document.addEventListener('DOMContentLoaded', function () {
    const videoWrappers = document.querySelectorAll('.mt-gallery-video-wrapper, .mt-main-product-video-wrapper');

    videoWrappers.forEach(function (wrapper) {
      const video = wrapper.querySelector('.mt-gallery-video');
      const mainVideo = wrapper.querySelector('.mt-main-product-video');
      const activeVideo = video || mainVideo;
      const overlay = wrapper.querySelector('.mt-gallery-video-overlay, .mt-main-product-video-overlay');
      const play = wrapper.querySelector('.mt-show, .mt-video-show');
      const pause = wrapper.querySelector('.mt-pause, .mt-video-pause');
      if (!activeVideo || !overlay) return;

      // Function to update icon state
      function updateIconState() {
        if (activeVideo.paused || activeVideo.ended) {
          if (play) play.style.display = 'block';
          if (pause) pause.style.display = 'none';
        } else {
          if (play) play.style.display = 'none';
          if (pause) pause.style.display = 'block';
        }
      }

      function toggleVideoPlayback() {
        if (activeVideo.paused || activeVideo.ended) {
          window.mtProductRequestVideoPlayback(activeVideo, { container: wrapper });
        } else {
          activeVideo.pause();
        }
      }

      overlay.addEventListener('click', function () {
        toggleVideoPlayback();
      });

      activeVideo.addEventListener('click', function () {
        toggleVideoPlayback();
      });

      // Listen to video events to update icon state
      activeVideo.addEventListener('play', function () {
        updateIconState();
      });

      activeVideo.addEventListener('pause', function () {
        updateIconState();
      });

      activeVideo.addEventListener('ended', function () {
        updateIconState();
      });

      // Initial state 
      updateIconState();
    });
  });

  // Product Tabs Functionality
  document.addEventListener('DOMContentLoaded', function () {
    const tabsWrappers = document.querySelectorAll('.mt-product-tabs-wrapper');

    tabsWrappers.forEach(function (wrapper) {
      const tabButtons = wrapper.querySelectorAll('.mt-product-tab-button');
      const tabPanels = wrapper.querySelectorAll('.mt-product-tab-panel');

      if (!tabButtons.length || !tabPanels.length) return;

      tabButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          const tabIndex = parseInt(button.getAttribute('data-tab-index'), 10);

          // Remove active class from all buttons and panels
          tabButtons.forEach(function (btn) {
            btn.classList.remove('active');
          });

          tabPanels.forEach(function (panel) {
            panel.classList.remove('active');
          });

          // Add active class to clicked button and corresponding panel
          button.classList.add('active');
          if (tabPanels[tabIndex]) {
            tabPanels[tabIndex].classList.add('active');
          }
        });
      });
    });
  });

  // Mobile Gallery Carousel Functionality
  document.addEventListener('DOMContentLoaded', function () {
    const mobileCarousels = document.querySelectorAll('.mt-mobile-gallery-carousel');

    mobileCarousels.forEach(function (carousel) {
      const slider = carousel.querySelector('.mt-mobile-gallery-slider');
      const slides = carousel.querySelectorAll('.mt-mobile-gallery-slide');
      const dots = carousel.querySelectorAll('.mt-mobile-gallery-dot');
      const wrapper = carousel.closest('.mt-mobile-gallery-carousel-wrapper');

      if (!slider || !slides.length || !dots.length) return;

      const autoplayInterval = wrapper ? parseInt(wrapper.getAttribute('data-autoplay-interval'), 10) || 0 : 0;
      let currentSlide = 0;
      let autoPlayTimer = null;
      let countdownTimers = [];
      const totalSlides = slides.length;

      // Create progress bar element for countdown animation
      function createProgressBar() {
        const progressBar = document.createElement('div');
        progressBar.className = 'mt-dot-progress';
        return progressBar;
      }

      // Show slide function
      function showSlide(index, resetTimer = true) {
        if (index < 0 || index >= totalSlides) return;

        // Remove active class from all slides and dots
        slides.forEach(function (slide) {
          slide.classList.remove('active');
        });

        dots.forEach(function (dot) {
          dot.classList.remove('active');
          dot.classList.remove('has-countdown');
          const progressBar = dot.querySelector('.mt-dot-progress');
          if (progressBar) {
            progressBar.style.width = '0%';
          }
        });

        // Move slider to show current slide using transform
        if (slider) {
          const translateX = -(index * 100);
          slider.style.transform = 'translateX(' + translateX + '%)';
        }

        // Add active class to current slide and dot
        if (slides[index]) {
          slides[index].classList.add('active');
          window.mtProductPrepareVideoElement(slides[index].querySelector('video'), { container: carousel });
        }

        if (dots[index]) {
          dots[index].classList.add('active');

          // Get or create progress bar (always create it for active dot)
          let progressBar = dots[index].querySelector('.mt-dot-progress');
          if (!progressBar) {
            progressBar = createProgressBar();
            dots[index].appendChild(progressBar);
          }

          // Add countdown if autoplay is enabled
          if (autoplayInterval > 0 && resetTimer) {
            dots[index].classList.add('has-countdown');

            // Reset progress bar to 0%
            progressBar.style.width = '0%';

            // Force a reflow to ensure the reset is applied
            progressBar.offsetHeight;

            // Start countdown animation
            startCountdown(index, autoplayInterval, progressBar);
          } else if (autoplayInterval > 0) {
            // If autoplay is enabled but resetTimer is false, still show progress
            // This handles the case when switching slides without resetting timer
            dots[index].classList.add('has-countdown');
            // Don't reset, let it continue from current state
          } else {
            // If no autoplay, show full progress bar for active dot
            progressBar.style.width = '100%';
          }
        }

        currentSlide = index;
      }

      // Initialize slider position
      if (slider) {
        slider.style.transform = 'translateX(0%)';
      }

      // Countdown function with progress bar fill animation
      function startCountdown(dotIndex, duration, progressBar) {
        // Clear any existing timer for this dot
        if (countdownTimers[dotIndex]) {
          clearInterval(countdownTimers[dotIndex]);
        }

        let timeLeft = duration;
        const totalTime = duration;
        const updateInterval = 16; // Update every 16ms (~60fps) for smooth animation
        const step = (updateInterval / 1000) / totalTime; // Calculate progress step per update

        // Reset progress bar
        if (progressBar) {
          progressBar.style.width = '0%';
        }

        const countdownInterval = setInterval(function () {
          timeLeft -= updateInterval / 1000;

          if (progressBar) {
            const progress = ((totalTime - timeLeft) / totalTime) * 100;
            progressBar.style.width = Math.min(progress, 100) + '%';
          }

          if (timeLeft <= 0) {
            if (progressBar) {
              progressBar.style.width = '100%';
            }
            clearInterval(countdownInterval);
            countdownTimers[dotIndex] = null;
          }
        }, updateInterval);

        countdownTimers[dotIndex] = countdownInterval;
      }

      // Next slide
      function nextSlide() {
        const next = (currentSlide + 1) % totalSlides;
        showSlide(next);
      }

      // Start autoplay
      function startAutoplay() {
        if (autoplayInterval <= 0 || autoPlayTimer) return;

        autoPlayTimer = setInterval(function () {
          nextSlide();
        }, autoplayInterval * 1000);
      }

      // Stop autoplay
      function stopAutoplay() {
        if (autoPlayTimer) {
          clearInterval(autoPlayTimer);
          autoPlayTimer = null;
        }

        // Clear all countdown timers
        countdownTimers.forEach(function (timer) {
          if (timer) {
            clearInterval(timer);
          }
        });
        countdownTimers = [];
      }

      // Dot click handlers
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          const dotIndex = parseInt(dot.getAttribute('data-dot-index'), 10);
          if (!isNaN(dotIndex)) {
            stopAutoplay();
            showSlide(dotIndex);
            if (autoplayInterval > 0) {
              setTimeout(startAutoplay, 100);
            }
          }
        });
      });

      // Touch/swipe support with direction detection and scroll conflict handling
      let touchStartX = 0;
      let touchStartY = 0;
      let touchEndX = 0;
      let touchEndY = 0;
      let isHorizontalSwipe = false;
      let isScrolling = false;
      let touchStartTime = 0;
      let touchMoved = false;
      const directionThreshold = 0.5; // Ratio to determine horizontal vs vertical (0.5 = 45 degrees)
      const minSwipeDistance = 30; // Minimum distance to trigger swipe

      // Touch start - record initial position
      slider.addEventListener('touchstart', function (e) {
        const touch = e.changedTouches[0];
        touchStartX = touch.screenX;
        touchStartY = touch.screenY;
        touchStartTime = Date.now();
        isHorizontalSwipe = false;
        isScrolling = false;
        touchMoved = false;
      }, { passive: true });

      // Touch move - detect direction and prevent scroll if horizontal
      slider.addEventListener('touchmove', function (e) {
        if (!touchStartX || !touchStartY) return;

        const touch = e.changedTouches[0];
        const deltaX = touch.screenX - touchStartX;
        const deltaY = touch.screenY - touchStartY;
        const absDeltaX = Math.abs(deltaX);
        const absDeltaY = Math.abs(deltaY);
        const totalDistance = Math.sqrt(absDeltaX * absDeltaX + absDeltaY * absDeltaY);

        // Only process if moved enough
        if (totalDistance > 10) {
          touchMoved = true;

          // Determine swipe direction based on angle
          if (!isHorizontalSwipe && !isScrolling) {
            // Calculate angle: if deltaX is dominant, it's horizontal
            const angle = Math.abs(Math.atan2(absDeltaY, absDeltaX));

            // If angle is less than 45 degrees (more horizontal), treat as horizontal swipe
            if (angle < Math.PI / 4 && absDeltaX > absDeltaY) {
              isHorizontalSwipe = true;
              // Prevent page scroll when horizontal swipe detected
              e.preventDefault();
              // Prevent body scroll temporarily
              const bodyOverflow = document.body.style.overflow;
              document.body.style.overflow = 'hidden';
              // Restore after a short delay to allow smooth scrolling
              setTimeout(function () {
                document.body.style.overflow = bodyOverflow;
              }, 100);
            } else if (absDeltaY > absDeltaX) {
              // More vertical movement - allow scrolling
              isScrolling = true;
            }
          } else if (isHorizontalSwipe) {
            // Continue preventing scroll during horizontal swipe
            e.preventDefault();
          }
        }
      }, { passive: false });

      // Touch end - handle swipe and restore scroll
      slider.addEventListener('touchend', function (e) {
        if (!touchStartX || !touchStartY || !touchMoved) {
          // Reset if no movement
          touchStartX = 0;
          touchStartY = 0;
          return;
        }

        const touch = e.changedTouches[0];
        touchEndX = touch.screenX;
        touchEndY = touch.screenY;

        // Restore body scroll
        document.body.style.overflow = '';

        // Only handle swipe if it was a horizontal gesture
        if (isHorizontalSwipe) {
          handleSwipe();
        }

        // Reset touch tracking
        touchStartX = 0;
        touchStartY = 0;
        touchEndX = 0;
        touchEndY = 0;
        isHorizontalSwipe = false;
        isScrolling = false;
        touchMoved = false;
      }, { passive: true });

      // Touch cancel - restore scroll
      slider.addEventListener('touchcancel', function (e) {
        document.body.style.overflow = '';
        touchStartX = 0;
        touchStartY = 0;
        touchEndX = 0;
        touchEndY = 0;
        isHorizontalSwipe = false;
        isScrolling = false;
        touchMoved = false;
      }, { passive: true });

      function handleSwipe() {
        const diff = touchStartX - touchEndX;
        const absDiff = Math.abs(diff);
        const timeDiff = Date.now() - touchStartTime;
        const maxSwipeTime = 500; // Maximum time for a swipe (ms)
        const minSwipeVelocity = 0.3; // Minimum velocity (pixels per ms)

        // Calculate velocity
        const velocity = absDiff / timeDiff;

        // Only process swipe if movement is significant, quick enough, and has sufficient velocity
        if (absDiff > minSwipeDistance && timeDiff < maxSwipeTime && velocity > minSwipeVelocity) {
          stopAutoplay();
          if (diff > 0) {
            // Swipe left - next slide
            nextSlide();
          } else {
            // Swipe right - previous slide
            const prev = (currentSlide - 1 + totalSlides) % totalSlides;
            showSlide(prev);
          }
          if (autoplayInterval > 0) {
            setTimeout(startAutoplay, 100);
          }
        }
      }

      // Initialize - find the first active slide
      let initialIndex = 0;
      slides.forEach(function (slide, index) {
        if (slide.classList.contains('active')) {
          initialIndex = index;
        }
      });

      // Set initial position
      if (slider) {
        slider.style.transform = 'translateX(-' + (initialIndex * 100) + '%)';
      }

      // Initialize slide display - use true to start countdown for first slide
      showSlide(initialIndex, true);

      if (autoplayInterval > 0) {
        startAutoplay();
      }

      // Pause autoplay on hover/touch
      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', function () {
        if (autoplayInterval > 0) {
          startAutoplay();
        }
      });

      // Pause autoplay when user interacts
      carousel.addEventListener('touchstart', stopAutoplay, { passive: true });
      carousel.addEventListener('touchend', function () {
        if (autoplayInterval > 0) {
          setTimeout(startAutoplay, 100);
        }
      }, { passive: true });
    });
  });
})();

// Thumbnail Gallery Functionality
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initThumbnailGallery();
  });

  function initThumbnailGallery() {
    const galleryWrapper = document.querySelector('.mt-custom-product-gallery-wrapper');
    if (!galleryWrapper) return;

    const mainProductImg = galleryWrapper.querySelector('.mt-main-product-media');
    const thumbnailsWrapper = galleryWrapper.querySelector('.mt-gallery-thumbnails-wrapper');
    if (!mainProductImg || !thumbnailsWrapper) return;

    const thumbnailsContainer = thumbnailsWrapper.querySelector('.mt-gallery-thumbnails-container');
    const thumbnails = thumbnailsWrapper.querySelector('.mt-gallery-thumbnails');
    const thumbnailItems = thumbnailsWrapper.querySelectorAll('.mt-gallery-thumbnail-item');
    const prevBtn = thumbnailsWrapper.querySelector('.mt-gallery-thumbnail-prev');
    const nextBtn = thumbnailsWrapper.querySelector('.mt-gallery-thumbnail-next');

    // Main product image navigation buttons
    const mainProductPrev = galleryWrapper.querySelector('.mt-main-product-prev');
    const mainProductNext = galleryWrapper.querySelector('.mt-main-product-next');

    if (!thumbnailsContainer || !thumbnails || !thumbnailItems.length) return;

    // Get all product media (images and videos) from current wrapper
    const productMedia = Array.from(thumbnailsWrapper.querySelectorAll('.mt-gallery-thumbnail-item')).map(function (item) {
      const mediaType = item.getAttribute('data-media-type') || 'image';
      const img = item.querySelector('img');
      const videoThumbnail = item.querySelector('.mt-gallery-thumbnail-video');

      return {
        index: parseInt(item.getAttribute('data-media-index') || item.getAttribute('data-image-index'), 10),
        type: mediaType,
        src: img ? img.src.replace(/width=\d+/, 'width=800') : '',
        thumbnail: item,
        videoSources: item.getAttribute('data-video-sources') || '',
        videoElement: null // Will be set when needed
      };
    }).sort(function (a, b) {
      return a.index - b.index;
    });

    let currentImageIndex = 0;
    const visibleThumbnails = 5; // Show 5 thumbnails at a time

    // Get main product wrapper
    const mainProductWrapper = galleryWrapper.querySelector('.mt-main-product-wrapper');

    // Update main product media (image or video)
    function updateMainImage(index) {
      if (index < 0 || index >= productMedia.length) return;

      currentImageIndex = index;
      const mediaData = productMedia[index];
      if (!mediaData || !mainProductWrapper) return;

      // Remove existing media
      const existingMedia = mainProductWrapper.querySelector('.mt-main-product-media');
      if (existingMedia) {
        // Pause video if playing
        const existingVideo = existingMedia.querySelector('video');
        if (existingVideo) {
          existingVideo.pause();
        }
        existingMedia.remove();
      }

      // Create new media element based on type
      if (mediaData.type === 'video') {
        // Create video wrapper
        const videoWrapper = document.createElement('div');
        videoWrapper.className = 'mt-main-product-media mt-main-product-video-wrapper';
        const videoElement = document.createElement('video');
        videoElement.className = 'mt-main-product-video';
        videoElement.controls = false;
        videoElement.autoplay = false;
        videoElement.playsInline = true;
        videoElement.preload = 'metadata';

        if (mediaData.src) {
          videoElement.poster = mediaData.src;
        }

        if (mediaData.videoSources) {
          let sources = [];

          try {
            sources = JSON.parse(mediaData.videoSources);
          } catch (error) {
            sources = [];
          }

          const progressiveSources = Array.isArray(sources) ? sources.filter(function (source) {
            if (!source || !source.url) return false;
            const mimeType = (source.mime_type || '').toLowerCase();
            const format = (source.format || '').toLowerCase();
            return mimeType.indexOf('mpegurl') === -1 && format !== 'm3u8';
          }) : [];

          const preferredSources = progressiveSources.length ? progressiveSources : sources;

          preferredSources.forEach(function (source) {
            if (!source || !source.url) return;

            const sourceElement = document.createElement('source');
            sourceElement.src = source.url;

            if (source.mime_type) {
              sourceElement.type = source.mime_type;
            }

            videoElement.appendChild(sourceElement);
          });

          if (preferredSources.length) {
            videoElement.load();
          }
        }

        // Video overlay
        const overlay = document.createElement('div');
        overlay.className = 'mt-main-product-video-overlay';
        const overlayBox = document.createElement('div');
        overlayBox.className = 'mt-main-product-video-overlay-box';

        overlayBox.innerHTML = `
          <svg class="mt-video-show" width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.3916 9.79009C16.2028 10.3772 16.2028 11.6228 15.3916 12.2099L2.23551 21.7321C1.29288 22.4144 -9.49177e-07 21.7146 -8.97054e-07 20.5222L-6.4597e-08 1.47781C-1.24739e-08 0.285369 1.29288 -0.41437 2.23552 0.267893L15.3916 9.79009Z" fill="#666666"/>
          </svg>
          <svg class="mt-video-pause" width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.12518 18.3996C5.12518 19.7386 4.03956 20.8251 2.70038 20.8254L2.45233 20.8127C1.2295 20.6884 0.274596 19.6552 0.274596 18.3996L0.274597 2.70038C0.274597 1.36109 1.36109 0.274597 2.70038 0.274597L2.94843 0.287292C4.17108 0.41174 5.12518 1.44504 5.12518 2.70038L5.12518 18.3996Z" fill="#666666" stroke="#666666" stroke-width="0.55" stroke-linecap="round"/>
            <path d="M19.425 18.3996C19.425 19.7386 18.3394 20.8251 17.0002 20.8254L16.7521 20.8127C15.5293 20.6884 14.5744 19.6552 14.5744 18.3996L14.5744 2.70038C14.5744 1.36109 15.6609 0.274597 17.0002 0.274597L17.2482 0.287292C18.4709 0.41174 19.425 1.44504 19.425 2.70038L19.425 18.3996Z" fill="#666666" stroke="#666666" stroke-width="0.55" stroke-linecap="round"/>
          </svg>
          <div class="mt-video-zz"></div>
        `;

        overlay.appendChild(overlayBox);
        videoWrapper.appendChild(videoElement);
        videoWrapper.appendChild(overlay);

        // Insert before navigation controls
        const navControls = mainProductWrapper.querySelector('.mt-main-product-nav');
        if (navControls) {
          mainProductWrapper.insertBefore(videoWrapper, navControls);
        } else {
          mainProductWrapper.appendChild(videoWrapper);
        }

        // Initialize video play/pause
        initVideoControls(videoWrapper);
      } else {
        // Create image element
        const img = document.createElement('img');
        img.className = 'mt-main-product mt-main-product-media';
        img.src = mediaData.src;
        img.alt = '{{ product.title }}';
        img.width = 800;
        img.height = 800;
        img.loading = 'lazy';

        // Insert before navigation controls
        const navControls = mainProductWrapper.querySelector('.mt-main-product-nav');
        if (navControls) {
          mainProductWrapper.insertBefore(img, navControls);
        } else {
          mainProductWrapper.appendChild(img);
        }
      }

      // Update active thumbnail
      thumbnailItems.forEach(function (item) {
        item.classList.remove('active');
      });
      if (mediaData.thumbnail) {
        mediaData.thumbnail.classList.add('active');

        // Scroll thumbnail into view
        scrollThumbnailIntoView(mediaData.thumbnail);
      }

      // Update main product nav buttons state
      updateMainNavButtons();
    }

    // Initialize video controls
    function initVideoControls(videoWrapper) {
      const video = videoWrapper.querySelector('video');
      const overlay = videoWrapper.querySelector('.mt-main-product-video-overlay');
      const playIcon = videoWrapper.querySelector('.mt-video-show');
      const pauseIcon = videoWrapper.querySelector('.mt-video-pause');

      if (!video || !overlay) return;

      // Function to update icon state
      function updateIconState() {
        if (video.paused || video.ended) {
          if (playIcon) playIcon.style.display = 'block';
          if (pauseIcon) pauseIcon.style.display = 'none';
        } else {
          if (playIcon) playIcon.style.display = 'none';
          if (pauseIcon) pauseIcon.style.display = 'block';
        }
      }

      function toggleVideoPlayback() {
        if (video.paused || video.ended) {
          window.mtProductRequestVideoPlayback(video, { container: videoWrapper });
        } else {
          video.pause();
        }
      }

      // Click overlay to play/pause
      overlay.addEventListener('click', function () {
        toggleVideoPlayback();
      });

      video.addEventListener('click', function () {
        toggleVideoPlayback();
      });

      // Listen to video events to update icon state
      video.addEventListener('play', function () {
        updateIconState();
      });

      video.addEventListener('pause', function () {
        updateIconState();
      });

      video.addEventListener('ended', function () {
        updateIconState();
      });

      // Initial state
      updateIconState();
    }

    // Update main product navigation buttons state
    function updateMainNavButtons() {
      if (mainProductPrev) {
        mainProductPrev.disabled = currentImageIndex === 0;
      }
      if (mainProductNext) {
        mainProductNext.disabled = currentImageIndex === productMedia.length - 1;
      }
    }

    // Navigate to previous image
    function prevMainImage() {
      if (currentImageIndex > 0) {
        updateMainImage(currentImageIndex - 1);
      }
    }

    // Navigate to next image
    function nextMainImage() {
      if (currentImageIndex < productMedia.length - 1) {
        updateMainImage(currentImageIndex + 1);
      }
    }

    // Scroll thumbnail into view using native scroll
    function scrollThumbnailIntoView(thumbnail) {
      if (!thumbnailsContainer || !thumbnail) return;

      const containerRect = thumbnailsContainer.getBoundingClientRect();
      const thumbnailRect = thumbnail.getBoundingClientRect();

      // Check if thumbnail is outside visible area
      if (thumbnailRect.left < containerRect.left) {
        // Scroll left to show thumbnail
        const scrollLeft = thumbnail.offsetLeft - thumbnailsContainer.offsetLeft - 10;
        thumbnailsContainer.scrollLeft = scrollLeft;
      } else if (thumbnailRect.right > containerRect.right) {
        // Scroll right to show thumbnail
        const scrollLeft = thumbnail.offsetLeft - thumbnailsContainer.offsetLeft - (containerRect.width - thumbnailRect.width) + 10;
        thumbnailsContainer.scrollLeft = scrollLeft;
      }

      updateNavButtons();
    }

    // Update navigation buttons state
    function updateNavButtons() {
      if (!prevBtn || !nextBtn || !thumbnailsContainer) return;

      const scrollLeft = thumbnailsContainer.scrollLeft;
      const containerWidth = thumbnailsContainer.offsetWidth;
      const thumbnailsWidth = thumbnails.scrollWidth;
      const maxScroll = Math.max(0, thumbnailsWidth - containerWidth);

      prevBtn.disabled = scrollLeft <= 0;
      nextBtn.disabled = scrollLeft >= maxScroll - 1; // Use -1 for floating point precision
    }

    // Scroll thumbnails using native scroll
    function scrollThumbnails(direction) {
      if (!thumbnailsContainer || !thumbnails) return;

      const containerWidth = thumbnailsContainer.offsetWidth;
      const thumbnailWidth = 120 + 10; // 120px width + 10px gap
      const scrollAmount = thumbnailWidth * 2; // Scroll 2 thumbnails at a time
      const currentScroll = thumbnailsContainer.scrollLeft;

      if (direction === 'prev') {
        thumbnailsContainer.scrollLeft = Math.max(0, currentScroll - scrollAmount);
      } else {
        const maxScroll = Math.max(0, thumbnails.scrollWidth - containerWidth);
        thumbnailsContainer.scrollLeft = Math.min(maxScroll, currentScroll + scrollAmount);
      }

      // Update buttons after scroll animation
      setTimeout(updateNavButtons, 300);
    }

    // Listen to scroll events to update nav buttons
    if (thumbnailsContainer) {
      thumbnailsContainer.addEventListener('scroll', function () {
        updateNavButtons();
      }, { passive: true });
    }

    // Click thumbnail to change main image/video
    thumbnailItems.forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.stopPropagation(); // Prevent event bubbling
        const index = parseInt(item.getAttribute('data-media-index') || item.getAttribute('data-image-index'), 10);
        updateMainImage(index);
      });
    });

    // Thumbnail navigation buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollThumbnails('prev');
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollThumbnails('next');
      });
    }

    // Main product image navigation buttons
    if (mainProductPrev) {
      mainProductPrev.addEventListener('click', function (e) {
        e.stopPropagation();
        prevMainImage();
      });
    }

    if (mainProductNext) {
      mainProductNext.addEventListener('click', function (e) {
        e.stopPropagation();
        nextMainImage();
      });
    }

    // Initialize - reset scroll position to 0
    if (thumbnailsContainer) {
      thumbnailsContainer.scrollLeft = 0;
    }

    updateMainImage(0);
    updateNavButtons();
    updateMainNavButtons();

    // Handle window resize
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        updateNavButtons();
        if (thumbnailItems[currentImageIndex]) {
          scrollThumbnailIntoView(thumbnailItems[currentImageIndex]);
        }
      }, 250);
    });
  }
})();

// Update mt-main-product image when variant changes
(function () {
  'use strict';

  function updateMainProductImage(variantId) {
    // Check if we're in gallery mode (with thumbnails)
    const galleryWrapper = document.querySelector('.mt-custom-product-gallery-wrapper');
    const mainProductWrapper = galleryWrapper ? galleryWrapper.querySelector('.mt-main-product-wrapper') : null;

    // Get main product image element (might not exist if video is showing)
    const mainProductImg = document.querySelector('.mt-main-product');

    // Normalize URLs for comparison (remove size parameters and query strings)
    function normalizeImageUrl(url) {
      if (!url) return '';
      // Remove size parameters like ?width=800 or &width=800
      url = url.replace(/[?&]width=\d+/g, '');
      // Remove other query parameters
      url = url.split('?')[0];
      // Remove size suffixes like _800x800
      url = url.replace(/_\d+x\d+/g, '');
      return url;
    }

    // Get variant image from the data we set in liquid
    if (window.productVariantImages && window.productVariantImages[variantId]) {
      const variantImageUrl = window.productVariantImages[variantId];

      // If we're in gallery mode, use the gallery's updateMainImage function
      if (galleryWrapper && mainProductWrapper) {
        // Get all thumbnails to find matching image
        const thumbnails = galleryWrapper.querySelectorAll('.mt-gallery-thumbnail-item');
        const normalizedVariantUrl = normalizeImageUrl(variantImageUrl);

        // Find matching thumbnail by comparing URLs
        let matchedThumbnail = null;
        thumbnails.forEach(function (thumbnail) {
          const mediaType = thumbnail.getAttribute('data-media-type') || 'image';
          // Only match images, not videos
          if (mediaType === 'image') {
            const thumbnailImg = thumbnail.querySelector('img');
            if (thumbnailImg) {
              const normalizedThumbnailUrl = normalizeImageUrl(thumbnailImg.src);
              const thumbnailUrl800 = thumbnailImg.src.replace(/width=\d+/, 'width=800');
              const normalizedThumbnailUrl800 = normalizeImageUrl(thumbnailUrl800);

              if (normalizedThumbnailUrl === normalizedVariantUrl ||
                normalizedThumbnailUrl800 === normalizedVariantUrl ||
                thumbnailImg.src.includes(normalizedVariantUrl.split('/').pop()) ||
                variantImageUrl.includes(normalizedThumbnailUrl.split('/').pop())) {
                matchedThumbnail = thumbnail;
              }
            }
          }
        });

        // If no exact match found, try filename match
        if (!matchedThumbnail) {
          const variantImageName = variantImageUrl.split('/').pop().split('?')[0];
          thumbnails.forEach(function (thumbnail) {
            const mediaType = thumbnail.getAttribute('data-media-type') || 'image';
            if (mediaType === 'image' && !matchedThumbnail) {
              const thumbnailImg = thumbnail.querySelector('img');
              if (thumbnailImg) {
                const thumbnailImageName = thumbnailImg.src.split('/').pop().split('?')[0];
                if (thumbnailImageName === variantImageName ||
                  thumbnailImageName.replace(/_\d+x\d+/, '') === variantImageName.replace(/_\d+x\d+/, '')) {
                  matchedThumbnail = thumbnail;
                }
              }
            }
          });
        }

        // If we found a match, switch to that image using the gallery's updateMainImage
        if (matchedThumbnail) {
          // Trigger thumbnail click to use existing gallery logic
          // This will call updateMainImage which handles video-to-image switching
          matchedThumbnail.click();
          return; // Exit early since thumbnail click will handle everything
        }
      }

      // Fallback: direct image update (for non-gallery mode or if match not found)
      if (mainProductImg) {
        mainProductImg.src = variantImageUrl;

        // Update thumbnail selection if thumbnail gallery exists (for non-gallery mode fallback)
        if (galleryWrapper) {
          const thumbnails = galleryWrapper.querySelectorAll('.mt-gallery-thumbnail-item');
          const thumbnailsContainer = galleryWrapper.querySelector('.mt-gallery-thumbnails-container');
          const normalizedVariantUrl = normalizeImageUrl(variantImageUrl);
          let foundMatch = false;

          // Find matching thumbnail by comparing normalized URLs
          thumbnails.forEach(function (thumbnail) {
            const thumbnailImg = thumbnail.querySelector('img');
            if (thumbnailImg) {
              const normalizedThumbnailUrl = normalizeImageUrl(thumbnailImg.src);
              const thumbnailUrl800 = thumbnailImg.src.replace(/width=\d+/, 'width=800');
              const normalizedThumbnailUrl800 = normalizeImageUrl(thumbnailUrl800);

              if (normalizedThumbnailUrl === normalizedVariantUrl ||
                normalizedThumbnailUrl800 === normalizedVariantUrl ||
                thumbnailImg.src.includes(normalizedVariantUrl.split('/').pop()) ||
                variantImageUrl.includes(normalizedThumbnailUrl.split('/').pop())) {
                thumbnail.classList.add('active');
                foundMatch = true;

                // Scroll thumbnail into view using native scroll
                if (thumbnailsContainer) {
                  const scrollLeft = thumbnail.offsetLeft - thumbnailsContainer.offsetLeft - 10;
                  thumbnailsContainer.scrollLeft = scrollLeft;
                }
              } else {
                thumbnail.classList.remove('active');
              }
            }
          });

          // If no exact match found, try to find by image ID or index
          if (!foundMatch && thumbnails.length > 0) {
            const variantImageName = variantImageUrl.split('/').pop().split('?')[0];
            thumbnails.forEach(function (thumbnail) {
              const thumbnailImg = thumbnail.querySelector('img');
              if (thumbnailImg) {
                const thumbnailImageName = thumbnailImg.src.split('/').pop().split('?')[0];
                if (thumbnailImageName === variantImageName ||
                  thumbnailImageName.replace(/_\d+x\d+/, '') === variantImageName.replace(/_\d+x\d+/, '')) {
                  thumbnail.classList.add('active');
                  foundMatch = true;

                  if (thumbnailsContainer) {
                    const scrollLeft = thumbnail.offsetLeft - thumbnailsContainer.offsetLeft - 10;
                    thumbnailsContainer.scrollLeft = scrollLeft;
                  }
                } else {
                  thumbnail.classList.remove('active');
                }
              }
            });
          }

          // If still no match, select first thumbnail as fallback
          if (!foundMatch && thumbnails.length > 0) {
            thumbnails[0].classList.add('active');
            if (thumbnailsContainer) {
              thumbnailsContainer.scrollLeft = 0;
            }
          }
        }
      }

      const normalizedVariantUrl = normalizeImageUrl(variantImageUrl);

      // Update mobile carousel slides
      const mobileCarousel = document.querySelector('.mt-mobile-gallery-carousel');
      if (mobileCarousel) {
        const mobileSlides = mobileCarousel.querySelectorAll('.mt-mobile-gallery-slide');
        const mobileDots = mobileCarousel.querySelectorAll('.mt-mobile-gallery-dot');

        // Clear all active states first
        mobileSlides.forEach(function (s) {
          s.classList.remove('active');
        });
        mobileDots.forEach(function (dot) {
          dot.classList.remove('active');
        });

        // Find matching slide by comparing normalized URLs
        let foundMobileMatch = false;
        let matchedIndex = -1;

        // First pass: try exact URL match
        for (let index = 0; index < mobileSlides.length; index++) {
          const slide = mobileSlides[index];
          const slideImg = slide.querySelector('img');
          if (slideImg && slide.getAttribute('data-media-type') === 'image') {
            const normalizedSlideUrl = normalizeImageUrl(slideImg.src);
            const slideUrl800 = slideImg.src.replace(/width=\d+/, 'width=800');
            const normalizedSlideUrl800 = normalizeImageUrl(slideUrl800);

            if (normalizedSlideUrl === normalizedVariantUrl ||
              normalizedSlideUrl800 === normalizedVariantUrl ||
              slideImg.src.includes(normalizedVariantUrl.split('/').pop()) ||
              variantImageUrl.includes(normalizedSlideUrl.split('/').pop())) {
              matchedIndex = index;
              foundMobileMatch = true;
              break; // Stop at first match
            }
          }
        }

        // Second pass: try filename match if no exact match found
        if (!foundMobileMatch) {
          const variantImageName = variantImageUrl.split('/').pop().split('?')[0];
          for (let index = 0; index < mobileSlides.length; index++) {
            const slide = mobileSlides[index];
            const slideImg = slide.querySelector('img');
            if (slideImg && slide.getAttribute('data-media-type') === 'image') {
              const slideImageName = slideImg.src.split('/').pop().split('?')[0];
              if (slideImageName === variantImageName ||
                slideImageName.replace(/_\d+x\d+/, '') === variantImageName.replace(/_\d+x\d+/, '')) {
                matchedIndex = index;
                foundMobileMatch = true;
                break; // Stop at first match
              }
            }
          }
        }

        // Set active state for matched slide and dot
        if (foundMobileMatch && matchedIndex >= 0) {
          if (mobileSlides[matchedIndex]) {
            mobileSlides[matchedIndex].classList.add('active');
          }
          if (mobileDots[matchedIndex]) {
            mobileDots[matchedIndex].classList.add('active');
          }
        } else if (mobileSlides.length > 0) {
          // Fallback to first slide
          mobileSlides[0].classList.add('active');
          if (mobileDots[0]) {
            mobileDots[0].classList.add('active');
          }
        }
      }
    } else if (window.productVariantImages) {
      // If variant doesn't have specific image, use first available variant image or product image
      const firstVariantId = Object.keys(window.productVariantImages)[0];
      if (firstVariantId && window.productVariantImages[firstVariantId]) {
        mainProductImg.src = window.productVariantImages[firstVariantId];
        // Also update thumbnail selection
        updateMainProductImage(firstVariantId);
      }
    }
  }

  function initVariantImageUpdater() {
    // Find the product form
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;

    // Find the variant ID input
    const variantIdInput = productForm.querySelector('input[name="id"]');
    if (!variantIdInput) return;

    // Listen for variant changes
    // Method 1: Listen to input change event
    variantIdInput.addEventListener('change', function () {
      const variantId = parseInt(variantIdInput.value, 10);
      if (variantId) {
        updateMainProductImage(variantId);
      }
    });

    // Method 2: Listen to custom variant:change event (Shopify standard)
    document.addEventListener('variant:change', function (event) {
      if (event.detail && event.detail.variant) {
        const variantId = event.detail.variant.id;
        if (variantId) {
          updateMainProductImage(variantId);
        }
      }
    });

    // Method 3: Listen to variant picker changes (for button/dropdown selectors)
    const variantPickers = productForm.querySelectorAll('[name^="options["], .product-form__input--dropdown select, .product-form__input input[type="radio"]');
    variantPickers.forEach(function (picker) {
      picker.addEventListener('change', function () {
        // Wait a bit for the variant ID input to update
        setTimeout(function () {
          const variantId = parseInt(variantIdInput.value, 10);
          if (variantId) {
            updateMainProductImage(variantId);
          }
        }, 100);
      });
    });

    // Initialize with current variant
    const currentVariantId = parseInt(variantIdInput.value, 10);
    if (currentVariantId) {
      updateMainProductImage(currentVariantId);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantImageUpdater);
  } else {
    initVariantImageUpdater();
  }

  // Also try after a short delay to catch dynamically loaded forms
  setTimeout(initVariantImageUpdater, 500);
})();

// Bundle Products Carousel and Cart Functionality
(function () {
  'use strict';

  // Debug probe: log every /cart/add.js request (fetch + XHR) with payload + stack
  // Enabled by default for troubleshooting bundle ATC issues.
  (function installCartAddDebugProbe() {
    try {
      if (window.__mtCartAddDebugProbeInstalled) return;
      window.__mtCartAddDebugProbeInstalled = true;

      function isCartAddUrl(url) {
        try {
          const u = String(url || '');
          return u.indexOf('/cart/add.js') !== -1;
        } catch (e) {
          return false;
        }
      }

      function tryParseJson(str) {
        try { return JSON.parse(str); } catch (e) { return null; }
      }

      function formDataToObject(fd) {
        const obj = {};
        try {
          fd.forEach(function (v, k) {
            // Keep small strings; avoid dumping files/blobs
            if (typeof v === 'string') obj[k] = v;
            else obj[k] = '[non-string]';
          });
        } catch (e) { }
        return obj;
      }

      function logCartAdd(kind, url, init) {
        try {
          const stack = (new Error()).stack;
          let body = init && init.body;
          let bodyOut = body;

          if (body && typeof body === 'string') {
            bodyOut = tryParseJson(body) || body;
          } else if (body && typeof FormData !== 'undefined' && body instanceof FormData) {
            bodyOut = formDataToObject(body);
            if (bodyOut && typeof bodyOut.id === 'string') {
              bodyOut.id = Number(bodyOut.id) || bodyOut.id;
            }
            if (bodyOut && typeof bodyOut.quantity === 'string') {
              bodyOut.quantity = Number(bodyOut.quantity) || bodyOut.quantity;
            }
            if (bodyOut && typeof bodyOut.sections === 'string') {
              bodyOut.sections = tryParseJson(bodyOut.sections) || bodyOut.sections;
            }
          }

          console.groupCollapsed('[MT CART ADD DEBUG]', kind, url);
          console.groupEnd();
        } catch (e) { }
      }

      // Patch fetch
      if (window.fetch && !window.__mtFetchPatchedForCartAdd) {
        window.__mtFetchPatchedForCartAdd = true;
        const originalFetch = window.fetch.bind(window);
        window.fetch = function (input, init) {
          const url = (typeof input === 'string') ? input : (input && input.url);
          const isCartAdd = isCartAddUrl(url);
          if (isCartAdd) logCartAdd('fetch', url, init || {});
          return originalFetch(input, init).then(function (res) {
            if (!isCartAdd) return res;
            try {
              const cloned = res.clone();
              cloned.text().then(function (text) {
                const parsed = tryParseJson(text);
                console.groupCollapsed('[MT CART ADD DEBUG] response', url, 'status:', res.status);
                console.groupEnd();
              }).catch(function () { });
            } catch (e) { }
            return res;
          });
        };
      }

      // Patch XHR (some themes still use it)
      if (window.XMLHttpRequest && !window.__mtXhrPatchedForCartAdd) {
        window.__mtXhrPatchedForCartAdd = true;
        const XHRProto = window.XMLHttpRequest.prototype;
        const origOpen = XHRProto.open;
        const origSend = XHRProto.send;
        XHRProto.open = function (method, url) {
          try { this.__mtUrl = url; this.__mtMethod = method; } catch (e) { }
          return origOpen.apply(this, arguments);
        };
        XHRProto.send = function (body) {
          try {
            if (isCartAddUrl(this.__mtUrl)) {
              logCartAdd('xhr', this.__mtUrl, { method: this.__mtMethod, body: body });
            }
          } catch (e) { }
          return origSend.apply(this, arguments);
        };
      }
    } catch (e) { }
  })();

  // Initialize bundle functionality for a specific block
  window.initBundleProducts = function (blockId, storefrontToken) {
    const containerId = 'mt-bundle-products-' + blockId;
    const wrapperId = 'mt-bundle-wrapper-' + blockId;
    const prevBtnId = 'mt-bundle-prev-' + blockId;
    const nextBtnId = 'mt-bundle-next-' + blockId;
    const indicatorsId = 'mt-bundle-indicators-' + blockId;

    const productCards = document.querySelectorAll('#' + containerId + ' .mt-bundle-product-card');
    const wrapper = document.getElementById(wrapperId);
    const prevBtn = document.getElementById(prevBtnId);
    const nextBtn = document.getElementById(nextBtnId);
    const indicators = document.querySelectorAll('#' + indicatorsId + ' .mt-bundle-indicator');

    let currentIndex = 0;
    let selectedProducts = new Set();

    if (productCards.length === 0) {
      return;
    }

    // Function to update carousel position
    function updateCarousel() {
      if (!wrapper) return;
      const translateX = -currentIndex * 100;
      wrapper.style.transform = 'translateX(' + translateX + '%)';

      // Update indicators
      indicators.forEach(function (indicator, index) {
        indicator.classList.toggle('active', index === currentIndex);
      });

      // Update navigation buttons
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex === productCards.length - 1;
    }

    // Function to toggle product selection
    function toggleProductSelection(productId, card) {
      // Ensure productId is a string for consistent comparison
      const productIdStr = String(productId);

      // Check current state from DOM (most reliable)
      const isCurrentlySelected = card.classList.contains('selected');

      // Toggle selection state
      if (isCurrentlySelected) {
        selectedProducts.delete(productIdStr);
        card.classList.remove('selected');
      } else {
        selectedProducts.add(productIdStr);
        card.classList.add('selected');
      }

      // Store in global scope for use by add to cart
      window.selectedBundleProducts = window.selectedBundleProducts || new Set();
      if (card.classList.contains('selected')) {
        window.selectedBundleProducts.add(productIdStr);
      } else {
        window.selectedBundleProducts.delete(productIdStr);
      }

      // Force a reflow to ensure CSS updates are applied
      card.offsetHeight;

      // Log current selection state for debugging
      const allSelected = document.querySelectorAll('.mt-bundle-product-card.selected');
    }

    // Function to get selected bundle products with quantities
    function getSelectedBundleItems() {
      const items = [];

      // Try to get selectedProducts from the bundle section
      let selectedProductIds = [];

      // Method 1: Use local selectedProducts Set
      if (selectedProducts && selectedProducts.size > 0) {
        selectedProductIds = Array.from(selectedProducts);
      }

      // Method 2: Try to access selectedProducts from the bundle section
      if (selectedProductIds.length === 0) {
        const bundleSection = document.querySelector('#' + containerId);
        if (bundleSection) {
          // Look for selected bundle product cards
          const selectedCards = bundleSection.querySelectorAll('.mt-bundle-product-card.selected');
          selectedProductIds = Array.from(selectedCards).map(function (card) {
            return card.dataset.productId;
          });
        }
      }

      // Method 3: If no bundle section found, try to find any selected bundle products
      if (selectedProductIds.length === 0) {
        const allSelectedCards = document.querySelectorAll('.mt-bundle-product-card.selected');
        selectedProductIds = Array.from(allSelectedCards).map(function (card) {
          return card.dataset.productId;
        });
      }


      selectedProductIds.forEach(function (productId) {
        const productCard = document.querySelector('[data-product-id="' + productId + '"]');
        if (productCard) {
          let variantId = productCard.getAttribute('data-variant-id');

          // Validate variant ID
          if (!variantId || variantId === 'undefined' || variantId === 'null' || variantId === '') {
            return; // Skip this item
          }

          const variantIdNum = parseInt(variantId, 10);
          if (isNaN(variantIdNum) || variantIdNum <= 0) {
            return; // Skip this item
          }

          const qtyInput = productCard.querySelector('.mt-bundle-qty');
          const qty = qtyInput ? Math.max(1, parseInt(qtyInput.value || '1', 10)) : 1;

          items.push({
            id: variantIdNum,
            quantity: qty
          });
        }
      });

      return items;
    }

    // Make functions accessible globally for event delegation
    window['getSelectedBundleItems_' + blockId] = getSelectedBundleItems;
    window['buildCartItems_' + blockId] = buildCartItems;
    window['selectedProducts_' + blockId] = selectedProducts;
    window['toGID_' + blockId] = toGID;
    window['storefrontCartCreate_' + blockId] = storefrontCartCreate;

    // Function to update cart icon bubble section
    function updateCartIconBubble(sectionsHtml) {
      if (!sectionsHtml || !sectionsHtml['cart-icon-bubble']) {
        // Fallback: update cart count manually
        updateCartIconCount();
        return;
      }

      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (!cartIconBubble) {
        // Fallback: update cart count manually
        updateCartIconCount();
        return;
      }

      try {
        // Parse the section HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionsHtml['cart-icon-bubble'], 'text/html');

        // Try to find the content in different ways
        // Method 1: Look for #cart-icon-bubble element
        let newContent = doc.querySelector('#cart-icon-bubble');

        // Method 2: Look for .shopify-section wrapper (standard Shopify format)
        if (!newContent) {
          newContent = doc.querySelector('.shopify-section');
        }

        // Method 3: If no specific element, try to find the actual content
        if (!newContent) {
          newContent = doc.body.firstElementChild || doc.body;
        }

        // Update the cart icon bubble
        if (newContent) {
          // Try to replace the entire element first
          const newCartIconBubble = doc.getElementById('cart-icon-bubble');
          if (newCartIconBubble) {
            cartIconBubble.outerHTML = newCartIconBubble.outerHTML;
          } else {
            // Fallback: update innerHTML
            cartIconBubble.innerHTML = newContent.innerHTML;
          }
        }

        // Dispatch cart updated event
        window.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (error) {
        // Fallback: update cart count manually
        updateCartIconCount();
      }
    }

    // Function to add selected bundle products to cart
    async function addSelectedBundleProducts() {
      // Get selected products from DOM (most reliable method)
      let selectedProductIds = [];

      // Method 1: Query DOM for selected bundle cards (most reliable)
      const selectedBundleCards = document.querySelectorAll('.mt-bundle-product-card.selected');
      selectedProductIds = Array.from(selectedBundleCards).map(function (card) {
        return card.getAttribute('data-product-id');
      }).filter(function (id) {
        return id && id !== 'undefined' && id !== 'null' && id !== '';
      });

      // Method 2: Fallback to local selectedProducts Set if DOM query found nothing
      if (selectedProductIds.length === 0 && selectedProducts && selectedProducts.size > 0) {
        selectedProductIds = Array.from(selectedProducts);
      }

      // Method 3: Fallback to global selectedBundleProducts if still nothing
      if (selectedProductIds.length === 0 && window.selectedBundleProducts && window.selectedBundleProducts.size > 0) {
        selectedProductIds = Array.from(window.selectedBundleProducts);
      }


      if (selectedProductIds.length === 0) {
        // Still return success since it's not an error - just no bundles to add
        return { success: true };
      }

      // Prepare items for batch add
      // Note: We need variant IDs, not product IDs for cart/add.js
      const items = [];

      // Use the selected cards we already found to ensure we get the right ones
      selectedBundleCards.forEach(function (card) {
        const productId = card.getAttribute('data-product-id');
        if (!productId || productId === 'undefined' || productId === 'null' || productId === '') {
          return; // Skip invalid product IDs
        }

        // Try to get variant ID from the card
        let variantId = card.getAttribute('data-variant-id');

        // If variantId is not set, try to get it from the product card's data
        if (!variantId || variantId === 'undefined' || variantId === 'null' || variantId === '') {
          return; // Skip items without valid variant ID
        }

        const qtyInput = card.querySelector('.mt-bundle-qty');
        const qty = qtyInput ? Math.max(1, parseInt(qtyInput.value || '1', 10)) : 1;

        // Ensure variantId is a valid number
        const variantIdNum = parseInt(variantId, 10);
        if (isNaN(variantIdNum) || variantIdNum <= 0) {
          return; // Skip invalid variant IDs
        }

        items.push({
          id: variantIdNum,
          quantity: qty,
        });


      });


      if (items.length === 0) {
        return { success: false, error: 'No valid bundle items found - check variant IDs' };
      }



      // Get cart elements (Dawn style)
      const cartDrawer = document.querySelector('cart-drawer');
      const cartNotification = document.querySelector('cart-notification');
      const cart = cartDrawer || cartNotification;

      // Build request config (Dawn style)
      let config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items }),
      };

      // Add sections for cart updates (Dawn style) - simplified
      if (cartNotification) {
        const sections = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
        config.body = JSON.stringify({
          items,
          sections: sections,
          sections_url: window.location.pathname,
        });
      } else if (cartDrawer) {
        // Simplified: just add cart-icon-bubble for count updates
        config.body = JSON.stringify({
          items,
          sections: ['cart-icon-bubble'],
          sections_url: window.location.pathname,
        });
      } else {
        // Even if no cart drawer/notification, still request cart-icon-bubble for count updates
        config.body = JSON.stringify({
          items,
          sections: ['cart-icon-bubble'],
          sections_url: window.location.pathname,
        });
      }



      try {
        const response = await fetch('/cart/add.js', config);


        // Get response text first to see what Shopify returns
        const responseText = await response.text();

        if (!response.ok) {
          let errorMessage = 'HTTP ' + response.status + ': ' + response.statusText;
          try {
            const errorData = JSON.parse(responseText);
            errorMessage = errorData.description || errorData.message || errorMessage;
          } catch (e) {
          }
          throw new Error(errorMessage);
        }

        const data = JSON.parse(responseText);

        if (data.status) {
          return { success: false, error: data.description || data.message };
        }

        // Update cart-icon-bubble section if sections were returned
        if (data.sections && data.sections['cart-icon-bubble']) {
          updateCartIconBubble(data.sections);
        } else {
          // Fallback: update cart count manually
          updateCartIconCount();
        }

        // Dispatch cart updated event for other listeners
        window.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { itemCount: data.item_count || 0 }
        }));

        // 兼容粘性加购等依赖 cart:refresh 的监听，确保成功路径都会触发刷新事件
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));

        return { success: true, data: data };
      } catch (error) {
        return { success: false, error: error.message || 'Network error' };
      }
    }

    // Function to submit main form
    async function submitMainForm(formEl) {
      const productForm = (formEl && formEl.tagName === 'FORM')
        ? formEl
        :
        document.querySelector('form[action*="/cart/add"]') ||
        document.querySelector('form[data-type="add-to-cart-form"]');
      if (!productForm) return { success: false };

      const formData = new FormData(productForm);
      const cartDrawer = document.querySelector('cart-drawer');
      const cartNotification = document.querySelector('cart-notification');

      let config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      };

      // Always request cart notification sections to ensure notification can be displayed
      const sections = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
      const formDataWithSections = new FormData(productForm);
      formDataWithSections.append('sections', JSON.stringify(sections));
      formDataWithSections.append('sections_url', window.location.pathname);
      config.body = formDataWithSections;

      try {
        try {
          const idVal = formDataWithSections.get('id');
          const qtyVal = formDataWithSections.get('quantity');
          const qtyInput =
            productForm.querySelector('input[name="quantity"]') ||
            document.querySelector('input[name="quantity"]');

        } catch (e) { }
        const response = await fetch('/cart/add.js', config);

        if (!response.ok) {
          throw new Error('HTTP ' + response.status + ': ' + response.statusText);
        }

        const data = await response.json();

        if (data.status) {
          return { success: false, error: data.description || data.message };
        }

        // Update cart-icon-bubble section if sections were returned
        if (data.sections && data.sections['cart-icon-bubble']) {
          updateCartIconBubble(data.sections);
        } else {
          // Fallback: update cart count manually
          updateCartIconCount();
        }

        // Dispatch cart updated event for other listeners
        window.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { itemCount: data.item_count || 0 }
        }));

        // 同样补发 cart:refresh，方便依赖该事件的组件（例如粘性加购 loading）及时结束
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));

        return { success: true, data: data };
      } catch (error) {
        try { console.error('[MT MAIN ATC] submit main product failed:', error); } catch (e) { }
        return { success: false, error: error.message || 'Network error' };
      }
    }

    // Function to update cart icon count
    function updateCartIconCount() {
      fetch('/cart.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (cartData) {
          const cartIconBubble = document.getElementById('cart-icon-bubble');

          // Update mt-circle based on cart count
          if (cartIconBubble) {
            const mtCircle = cartIconBubble.querySelector('.mt-circle');
            if (cartData.item_count > 0) {
              // Add mt-circle if it doesn't exist
              if (!mtCircle) {
                const svgWrapper = cartIconBubble.querySelector('.svg-wrapper');
                if (svgWrapper) {
                  const circle = document.createElement('span');
                  circle.className = 'mt-circle';
                  cartIconBubble.insertBefore(circle, svgWrapper);
                }
              }
            } else {
              // Remove mt-circle if cart is empty
              if (mtCircle) {
                mtCircle.remove();
              }
            }
          }

          const cartCountBubble = document.querySelector('.cart-count-bubble');
          if (cartCountBubble) {
            const visibleSpan = cartCountBubble.querySelector('span[aria-hidden="true"]');
            if (visibleSpan) {
              visibleSpan.textContent = cartData.item_count;
            }

            const screenReaderSpan = cartCountBubble.querySelector('span.visually-hidden');
            if (screenReaderSpan) {
              screenReaderSpan.textContent = cartData.item_count + ' items';
            }
          }

          document.querySelectorAll('[data-cart-count], .cart-count, .cart__count').forEach(function (el) {
            el.textContent = cartData.item_count;
          });

          window.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { itemCount: cartData.item_count }
          }));
        })
        .catch(function (error) {
        });
    }

    // Function to open cart drawer
    function openCartDrawer() {

      const cartDrawer = document.querySelector('cart-drawer');
      const cartNotification = document.querySelector('cart-notification');



      if (cartDrawer) {
        updateCartIconCount();

        // Always refresh the drawer content before opening to ensure it's up to date
        // Get the section ID from the cart-drawer element
        const sectionId = cartDrawer.getAttribute('section');
        const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
          ? window.Shopify.routes.root
          : '/';

        // Use mini-cart as default section ID if not specified
        const sectionToFetch = sectionId || 'mini-cart';
        const sectionUrl = rootUrl + '?section_id=' + sectionToFetch;



        fetch('/cart.js')
          .then(function (response) {
            return response.json();
          })
          .then(function (cartData) {
            if (cartData.item_count === 0) {
              // If cart is empty, just open the drawer
              cartDrawer.open = true;
              return;
            }

            return fetch(sectionUrl);
          })
          .then(function (response) {

            if (!response || !response.ok) {
              // If fetch failed, just open the existing drawer
              cartDrawer.open = true;
              return null;
            }
            return response.text();
          })
          .then(function (responseText) {

            if (!responseText) {
              // If no response, just open the existing drawer
              cartDrawer.open = true;
              return;
            }

            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newCartDrawer = html.querySelector('cart-drawer');

            if (newCartDrawer) {
              const parent = cartDrawer.parentNode;
              if (parent) {
                // Replace the old drawer with the new one containing updated content
                parent.replaceChild(newCartDrawer, cartDrawer);

                // Update reference to the new element
                const updatedCartDrawer = document.querySelector('cart-drawer');

                // Wait for custom element to initialize, then set open attribute
                setTimeout(function () {
                  if (updatedCartDrawer) {
                    updatedCartDrawer.open = true;
                  } else {
                    // Fallback: try to find and open any cart drawer
                    const fallbackDrawer = document.querySelector('cart-drawer');
                    if (fallbackDrawer) {
                      fallbackDrawer.open = true;
                    }
                  }
                }, 300); // Increased delay to ensure custom element is fully initialized
              } else {
                // Fallback: try to update innerHTML if possible
                try {
                  const drawerContent = newCartDrawer.querySelector('.cart-drawer__inner') ||
                    newCartDrawer.querySelector('[class*="cart"]');
                  if (drawerContent && cartDrawer.querySelector('.cart-drawer__inner')) {
                    cartDrawer.querySelector('.cart-drawer__inner').innerHTML = drawerContent.innerHTML;
                  }
                  cartDrawer.open = true;
                } catch (e) {
                  cartDrawer.open = true;
                }
              }
            } else {
              // Try to trigger cart:refresh event which should update the drawer
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: {
                  openMiniCart: true
                }
              }));
              // Also try to open the existing drawer
              setTimeout(function () {
                cartDrawer.open = true;
              }, 100);
            }
          })
          .catch(function (error) {
            // On error, just open the existing drawer
            cartDrawer.open = true;
          });
      } else if (cartNotification) {
        try {
          // cart-notification might also use open attribute or open() method
          if (typeof cartNotification.open === 'function') {
            cartNotification.open();
          } else {
            cartNotification.open = true;
          }
        } catch (e) {
        }
      } else {
        // If no cart drawer or notification, try to trigger cart:refresh event
        // which will be handled by the theme's cart drawer component
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            openMiniCart: true
          }
        }));
      }
    }

    // Function to build cart items for buy now
    async function buildCartItems() {
      const items = [];

      const productForm = document.querySelector('form[action*="/cart/add"]') ||
        document.querySelector('form[data-type="add-to-cart-form"]');

      if (productForm) {
        const idInput = productForm.querySelector('input[name="id"]');
        const qtyInput = productForm.querySelector('input[name="quantity"]');

        if (idInput) {
          const id = Number(idInput.value);
          const qty = Math.max(1, parseInt(qtyInput ? qtyInput.value : '1' || '1', 10));
          items.push({ id, quantity: qty });
        }
      }

      // Get selected bundle products directly from DOM (works across all bundle blocks)
      const selectedBundleCards = document.querySelectorAll('.mt-bundle-product-card.selected');

      let bundleCount = 0;
      selectedBundleCards.forEach(function (card) {
        const variantId = card.getAttribute('data-variant-id');

        // Validate variant ID
        if (!variantId || variantId === 'undefined' || variantId === 'null' || variantId === '') {
          return;
        }

        const variantIdNum = parseInt(variantId, 10);
        if (isNaN(variantIdNum) || variantIdNum <= 0) {
          return;
        }

        const qtyInput = card.querySelector('.mt-bundle-qty');
        const qty = qtyInput ? Math.max(1, parseInt(qtyInput.value || '1', 10)) : 1;

        bundleCount++;
        items.push({
          id: variantIdNum,
          quantity: qty
        });
      });

      const merged = {};
      items.forEach(function (item) {
        if (!item || !item.id) {
          return;
        }
        if (!merged[item.id]) {
          merged[item.id] = { id: item.id, quantity: 0 };
        }
        merged[item.id].quantity += Number(item.quantity || 1);
      });

      const finalItems = Object.keys(merged).map(function (key) {
        return merged[key];
      });

      return finalItems;
    }

    // Convert variant ID to Shopify GID format
    function toGID(id) {
      return 'gid://shopify/ProductVariant/' + Number(id);
    }

    // Create cart using Storefront API
    async function storefrontCartCreate(lines, token) {
      const query = '\n                            mutation CartCreate($lines: [CartLineInput!]!) {\n                              cartCreate(input: { \n                                lines: $lines\n                              }) {\n                                cart { checkoutUrl }\n                                userErrors { message }\n                              }\n                            }';

      const res = await fetch('/api/2024-07/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({ query: query, variables: { lines: lines } })
      });

      const json = await res.json();

      const url = json && json.data && json.data.cartCreate && json.data.cartCreate.cart && json.data.cartCreate.cart.checkoutUrl;
      const err = (json && json.errors && json.errors[0] && json.errors[0].message) ||
        (json && json.data && json.data.cartCreate && json.data.cartCreate.userErrors && json.data.cartCreate.userErrors[0] && json.data.cartCreate.userErrors[0].message) ||
        ('HTTP ' + res.status);

      if (!url) {
        throw new Error(err || 'cartCreate failed');
      }

      return url;
    }

    // Function to setup buy now button listeners
    function setupBuyNowListeners() {
      // Try multiple selectors to find buy now buttons
      const buyNowButton = document.querySelector('.shopify-payment-button__button') ||
        document.querySelector('.mt-now-buy') ||
        document.querySelector('a[href*="checkout"]');
      const buyNowButton2 = document.querySelector('.mt-now-buy2') ||
        document.querySelector('.shopify-payment-button__button--unbranded');

      // Try to find all possible buy now buttons for debugging
      const allBuyNowButtons = document.querySelectorAll('.shopify-payment-button__button, .mt-now-buy, .mt-now-buy2, a[href*="checkout"], button[formaction*="checkout"]');
      allBuyNowButtons.forEach(function (btn, idx) {
      });

      return { buyNowButton: buyNowButton, buyNowButton2: buyNowButton2 };
    }

    // Intercept product form submit and buy now buttons
    const productForm = document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[data-type="add-to-cart-form"]');
    const submitButton = document.querySelector('.mt-product-form__submit') ||
      document.querySelector('.product-form__submit') ||
      document.querySelector('button[type="submit"][name="add"]');

    // Initial button lookup
    let buyNowButtons = setupBuyNowListeners();
    let buyNowButton = buyNowButtons.buyNowButton;
    let buyNowButton2 = buyNowButtons.buyNowButton2;


    const shopifyPaymentButton = document.querySelector('.shopify-payment-button__button');
    const actualBuyNowButton = buyNowButton || shopifyPaymentButton;

    // Function to setup buy now button handler
    function setupBuyNowButtonHandler(button) {
      if (!button) return;
      // Prevent duplicate listeners
      if (button.hasAttribute('data-mt-buynow-handler-attached')) {
        return;
      }
      button.setAttribute('data-mt-buynow-handler-attached', 'true');

      button.addEventListener('click', async function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const token = window.__SF_TOKEN__ || storefrontToken;
        if (!token) {
          return;
        }

        const items = await buildCartItems();
        if (!items.length) {
          return;
        }


        const lines = items.map(function (it) {
          return {
            quantity: Number(it.quantity || 1),
            merchandiseId: toGID(it.id)
          };
        });


        if (button.disabled !== undefined) {
          button.disabled = true;
        } else {
          button.style.pointerEvents = 'none';
          button.style.opacity = '0.5';
        }

        try {
          const checkoutUrl = await storefrontCartCreate(lines, token);
          window.location.href = checkoutUrl;
        } catch (err) {
          if (button.disabled !== undefined) {
            button.disabled = false;
          } else {
            button.style.pointerEvents = 'auto';
            button.style.opacity = '1';
          }
          if (err.message && (err.message.includes('401') || err.message.includes('Unauthorized'))) {
          } else {
          }
        }
      }, { capture: true, passive: false });
    }

    // Retry finding buy now buttons after a delay (in case they load later)
    setTimeout(function () {
      const retryResult = setupBuyNowListeners();
      const retryShopifyButton = document.querySelector('.shopify-payment-button__button');
      const retryActualButton = retryResult.buyNowButton || retryShopifyButton;

      if (!actualBuyNowButton && retryActualButton) {
        setupBuyNowButtonHandler(retryActualButton);
      }
      if (!buyNowButton2 && retryResult.buyNowButton2) {
        buyNowButton2 = retryResult.buyNowButton2;
        // Use the setupBuyNowButton2Listener function which properly handles <a> tags
        setupBuyNowButton2Listener(buyNowButton2);
      }
    }, 500);

    // Use MutationObserver to watch for Shopify payment button (it loads dynamically)
    const paymentButtonObserver = new MutationObserver(function (mutations) {
      const shopifyButton = document.querySelector('.shopify-payment-button__button');
      if (shopifyButton && !shopifyButton.hasAttribute('data-mt-buynow-handler-attached')) {
        setupBuyNowButtonHandler(shopifyButton);
      }
    });

    // Start observing
    paymentButtonObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also retry multiple times with setTimeout
    let retryCount = 0;
    const maxRetries = 10;
    const retryInterval = setInterval(function () {
      retryCount++;
      const shopifyButton = document.querySelector('.shopify-payment-button__button');
      if (shopifyButton && !shopifyButton.hasAttribute('data-mt-buynow-handler-attached')) {
        setupBuyNowButtonHandler(shopifyButton);
      }
      if (retryCount >= maxRetries) {
        clearInterval(retryInterval);
        paymentButtonObserver.disconnect();
      }
    }, 500);

    if (actualBuyNowButton) {
      setupBuyNowButtonHandler(actualBuyNowButton);
    }

    // Handle buy now button2 click - Direct checkout with Storefront API
    if (buyNowButton2) {
      // Use the setupBuyNowButton2Listener function which properly handles <a> tags
      setupBuyNowButton2Listener(buyNowButton2);
    } else {
      // If button not found initially, set up observer to watch for it
      const observer = new MutationObserver(function (mutations) {
        const foundButton = document.querySelector('.mt-now-buy2');
        if (foundButton && !foundButton.hasAttribute('data-mt-listener-attached')) {
          foundButton.setAttribute('data-mt-listener-attached', 'true');
          setupBuyNowButton2Listener(foundButton);
          observer.disconnect(); // Stop observing once we've attached the listener
        }
      });

      // Start observing
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Also retry a few more times with setTimeout as backup
      let retryCount = 0;
      const maxRetries = 10;
      const retryInterval = setInterval(function () {
        retryCount++;
        const foundButton = document.querySelector('.mt-now-buy2');
        if (foundButton && !foundButton.hasAttribute('data-mt-listener-attached')) {
          foundButton.setAttribute('data-mt-listener-attached', 'true');
          setupBuyNowButton2Listener(foundButton);
          observer.disconnect();
          clearInterval(retryInterval);
        } else if (retryCount >= maxRetries) {
          observer.disconnect();
          clearInterval(retryInterval);
        }
      }, 500);
    }

    // Function to setup buy now button listener
    function setupBuyNowButtonListener(btn) {
      if (!btn) return;
      btn.addEventListener('click', async function (e) {

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const token = window.__SF_TOKEN__ || storefrontToken;


        if (!token) {
          return;
        }

        const items = await buildCartItems();

        if (!items.length) {
          return;
        }


        const lines = items.map(function (it) {
          return {
            quantity: Number(it.quantity || 1),
            merchandiseId: toGID(it.id)
          };
        });


        if (btn.disabled !== undefined) {
          btn.disabled = true;
        } else {
          btn.style.pointerEvents = 'none';
          btn.style.opacity = '0.5';
        }

        try {
          const checkoutUrl = await storefrontCartCreate(lines, token);
          window.location.href = checkoutUrl;
        } catch (err) {
          if (btn.disabled !== undefined) {
            btn.disabled = false;
          } else {
            btn.style.pointerEvents = 'auto';
            btn.style.opacity = '1';
          }

        }
      }, { passive: false, capture: true });
    }

    // Function to setup buy now button2 listener
    function setupBuyNowButton2Listener(btn) {
      if (!btn) return;
      // Prevent duplicate listeners
      if (btn.hasAttribute('data-mt-listener-attached')) {
        return;
      }
      btn.setAttribute('data-mt-listener-attached', 'true');
      btn.addEventListener('click', async function (e) {

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const token = window.__SF_TOKEN__ || storefrontToken;

        if (!token) {
          return;
        }

        // Build cart items (main product + selected bundle products)
        const items = await buildCartItems();

        if (!items.length) {
          return;
        }


        const lines = items.map(function (it) {
          return {
            quantity: Number(it.quantity || 1),
            merchandiseId: toGID(it.id)
          };
        });

        if (btn.disabled !== undefined) {
          btn.disabled = true;
        } else {
          btn.style.pointerEvents = 'none';
          btn.style.opacity = '0.5';
        }

        try {
          const checkoutUrl = await storefrontCartCreate(lines, token);
          window.location.href = checkoutUrl;
        } catch (err) {

          if (btn.disabled !== undefined) {
            btn.disabled = false;
          } else {
            btn.style.pointerEvents = 'auto';
            btn.style.opacity = '1';
          }


        }
      }, { passive: false, capture: true });
    }

    // Handle form submission - use capture phase to intercept before ProductForm
    if (productForm) {
      // Check if form uses ProductForm custom element (is="product-form")
      const isProductFormElement = productForm.hasAttribute('is') && productForm.getAttribute('is') === 'product-form';

      // Use capture phase to intercept before ProductForm's handler
      productForm.addEventListener('submit', async function (e) {

        // Check if we have bundle products to add by querying DOM
        const selectedBundleCards = document.querySelectorAll('.mt-bundle-product-card.selected');
        const hasSelectedBundles = selectedBundleCards.length > 0;

        // Only intercept if we have bundle products to add
        if (hasSelectedBundles) {
          // Prevent duplicate bundle+main submissions caused by both submit and click handlers firing
          if (window.__mtBundleAtcInFlight) return;
          window.__mtBundleAtcInFlight = true;
          // Prevent default to handle bundle products first
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation(); // Also stop other handlers

          try {
            // Add bundle products first
            const bundleResult = await addSelectedBundleProducts();

            if (!bundleResult.success) {
              // alert('添加捆绑商品失败: ' + (bundleResult.error || '未知错误'));
              return; // Don't proceed with main form if bundle add failed
            }

            // Now submit the main form
            if (isProductFormElement) {
              // If using ProductForm, we need to manually trigger its submit handler
              // But ProductForm's _onSubmit is a private method, so we'll use submitMainForm
              // and then trigger the ProductForm's events
              const mainResult = await submitMainForm(productForm);

              if (bundleResult.success && mainResult.success && mainResult.data) {

                // Dispatch variant:added event
                productForm.dispatchEvent(new CustomEvent('variant:added', {
                  bubbles: true,
                  detail: {
                    variant: mainResult.data.hasOwnProperty('items')
                      ? mainResult.data.items[0]
                      : mainResult.data
                  }
                }));

                // Trigger cart notification first (this shows the notification popup)
                // The notification will use sections data from mainResult.data
                productForm.dispatchEvent(new CustomEvent('cart-notification:show', {
                  bubbles: true,
                  cancelable: true,
                  detail: {
                    status: 'success',
                    error: ''
                  }
                }));

                // 不再在这里额外请求 /cart.js，而是直接通过 cart:refresh 交给主题统一处理
                const cartType = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType)
                  ? window.themeVariables.settings.cartType
                  : 'drawer';

                const openMiniCart = cartType === 'drawer' && productForm.closest('.drawer') === null;

                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true,
                  detail: {
                    // 直接把 sections 透传给监听方，避免重复请求
                    sections: mainResult.data.sections || null,
                    openMiniCart: openMiniCart
                  }
                }));
              }
            } else {
              // Not using ProductForm, use our custom handler
              const mainResult = await submitMainForm(productForm);

              if (bundleResult.success && mainResult.success) {
                // Trigger cart:refresh event if we have sections data
                if (mainResult.data && mainResult.data.sections) {
                  // 通过 cart:refresh 提示主题更新并按需打开抽屉
                  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true,
                    detail: {
                      sections: mainResult.data.sections,
                      openMiniCart: true
                    }
                  }));
                } else {
                  // 没有 sections 时至少让主题更新一次
                  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true,
                    detail: {
                      openMiniCart: true
                    }
                  }));
                }

                // 这里不再手动调用 openCartDrawer，避免与主题自身监听重复弹出
              } else {
                // 保留 500ms 作为兜底（仅更新角标，不打开抽屉）
                setTimeout(function () {
                  updateCartIconCount();
                }, 500);
              }
            }
          } finally {
            window.__mtBundleAtcInFlight = false;
          }
        }
        // If no bundle products, let ProductForm handle it normally (don't prevent default)
      }, { passive: false, capture: true }); // Use capture phase to intercept early
    }

    // Handle submit button click (backup handler) - use capture phase
    if (submitButton) {
      submitButton.addEventListener('click', async function (e) {

        // Check if we have bundle products to add by querying DOM
        const selectedBundleCards = document.querySelectorAll('.mt-bundle-product-card.selected');
        const hasSelectedBundles = selectedBundleCards.length > 0;


        // Only handle if form submit didn't already handle it
        if (hasSelectedBundles) {
          // Prevent duplicate bundle+main submissions caused by both submit and click handlers firing
          if (window.__mtBundleAtcInFlight) return;
          window.__mtBundleAtcInFlight = true;
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation(); // Stop other handlers

          try {
            // Add bundle products first
            const bundleResult = await addSelectedBundleProducts();

            if (!bundleResult.success) {
              // alert('添加捆绑商品失败: ' + (bundleResult.error || '未知错误'));
              return; // Don't proceed with main form if bundle add failed
            }

            // Now submit the main form (Dawn style)
            const formFromClick =
              (submitButton && submitButton.closest && submitButton.closest('form')) ||
              (productForm && productForm.tagName === 'FORM' ? productForm : null);
            const mainResult = await submitMainForm(formFromClick);

            // Only open cart drawer if both operations were successful
            if (bundleResult.success && mainResult.success) {
              // 统一在这里通过 cart:refresh 告诉主题更新并按需打开抽屉（只触发一次）
              if (mainResult.data && mainResult.data.sections) {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true,
                  detail: {
                    sections: mainResult.data.sections,
                    openMiniCart: true
                  }
                }));
              } else {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true,
                  detail: {
                    openMiniCart: true
                  }
                }));
              }
            } else {
              // Still update cart count
              setTimeout(function () {
                updateCartIconCount();
              }, 500);
            }
          } finally {
            window.__mtBundleAtcInFlight = false;
          }
        }
        // If no bundle products, let form submit handler take care of it
      }, { passive: false, capture: true }); // Use capture phase to intercept early
    }

    // Checkbox click functionality
    productCards.forEach(function (card) {
      const checkbox = card.querySelector('.mt-bundle-selection-indicator');
      const productId = card.getAttribute('data-product-id'); // Use getAttribute instead of dataset

      if (checkbox) {
        // Add click event to checkbox
        checkbox.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          toggleProductSelection(productId, card);
        });

        // Also add click event to the entire card for better UX
        card.addEventListener('click', function (e) {
          // Don't trigger if clicking on quantity controls or links
          if (e.target.closest('.mt-bundle-qty-wrap') ||
            e.target.closest('.mt-bundle-product-title') ||
            e.target.closest('.mt-bundle-qty') ||
            e.target.closest('.mt-bundle-qty-btn')) {
            return;
          }

          e.preventDefault();
          e.stopPropagation();
          toggleProductSelection(productId, card);
        });
      } else {
        // If checkbox not found, still allow card click
        card.addEventListener('click', function (e) {
          // Don't trigger if clicking on quantity controls or links
          if (e.target.closest('.mt-bundle-qty-wrap') ||
            e.target.closest('.mt-bundle-product-title') ||
            e.target.closest('.mt-bundle-qty') ||
            e.target.closest('.mt-bundle-qty-btn')) {
            return;
          }

          e.preventDefault();
          e.stopPropagation();
          toggleProductSelection(productId, card);
        });
      }

      // Quantity controls
      const qtyInput = card.querySelector('.mt-bundle-qty');
      const minusBtn = card.querySelector('.mt-bundle-qty-btn.minus');
      const plusBtn = card.querySelector('.mt-bundle-qty-btn.plus');

      if (minusBtn && qtyInput) {
        minusBtn.addEventListener('click', function () {
          const val = parseInt(qtyInput.value, 10) || 1;
          if (val > 1) qtyInput.value = val - 1;
        });
      }

      if (plusBtn && qtyInput) {
        plusBtn.addEventListener('click', function () {
          const val = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = val + 1;
        });
      }
    });
    // Navigation functionality
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (currentIndex > 0) {
          currentIndex--;
          updateCarousel();
        }
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (currentIndex < productCards.length - 1) {
          currentIndex++;
          updateCarousel();
        }
      });
    }

    // Indicator click functionality
    indicators.forEach(function (indicator, index) {
      indicator.addEventListener('click', function () {
        currentIndex = index;
        updateCarousel();
      });
    });

    // Touch/swipe support for mobile
    if (wrapper) {
      let startX = 0;
      let endX = 0;

      wrapper.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      });

      wrapper.addEventListener('touchend', function (e) {
        endX = e.changedTouches[0].clientX;
        handleSwipe();
      });

      function handleSwipe() {
        const swipeThreshold = 50;
        const diff = startX - endX;

        if (Math.abs(diff) > swipeThreshold) {
          if (diff > 0 && currentIndex < productCards.length - 1) {
            currentIndex++;
            updateCarousel();
          } else if (diff < 0 && currentIndex > 0) {
            currentIndex--;
            updateCarousel();
          }
        }
      }
    }

    // Initialize
    updateCarousel();
  };
})();

// Variant Picker and Quantity Selector Functionality
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initVariantPicker();
    initQuantitySelector();
  });

  // Initialize variant picker
  function initVariantPicker() {
    const variantButtonGroups = document.querySelectorAll('.mt-variant-buttons');
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[action*="/cart/add"]');

    if (!productForm || !variantButtonGroups.length) return;

    const variantIdInput = productForm.querySelector('input[name="id"]');
    if (!variantIdInput) return;

    // Get all variants data from window object
    const variants = window.productVariants || [];

    variantButtonGroups.forEach(function (buttonGroup) {
      const buttons = buttonGroup.querySelectorAll('.mt-variant-button');
      const optionIndex = parseInt(buttonGroup.getAttribute('data-option-index'), 10);
      const productInfoContainer = buttonGroup.closest('[id^="ProductInfo-"]');
      const sectionId = productInfoContainer ? productInfoContainer.id.replace('ProductInfo-', '') : '';
      const selectedSpan = document.querySelector('#mt-variant-selected-' + sectionId + '-' + optionIndex);

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          if (button.classList.contains('disabled')) return;

          // Remove active class from all buttons in this group
          buttons.forEach(function (btn) {
            btn.classList.remove('active');
          });

          // Add active class to clicked button
          button.classList.add('active');

          // Update selected text
          if (selectedSpan) {
            selectedSpan.textContent = button.getAttribute('data-value');
          }

          // Find matching variant
          const selectedOptions = [];
          document.querySelectorAll('.mt-variant-buttons').forEach(function (group) {
            const activeButton = group.querySelector('.mt-variant-button.active');
            if (activeButton) {
              selectedOptions.push(activeButton.getAttribute('data-value'));
            }
          });

          // Find matching variant
          const matchedVariant = variants.find(function (variant) {
            return variant.options.every(function (option, index) {
              return selectedOptions[index] === option;
            });
          });

          if (matchedVariant && variantIdInput) {
            variantIdInput.value = matchedVariant.id;

            // Manually trigger change event to ensure all listeners are notified
            const changeEvent = new Event('change', { bubbles: true });
            variantIdInput.dispatchEvent(changeEvent);

            // Dispatch variant change event (Shopify standard)
            const variantChangeEvent = new CustomEvent('variant:change', {
              bubbles: true,
              detail: { variant: matchedVariant }
            });
            document.dispatchEvent(variantChangeEvent);
            variantIdInput.dispatchEvent(variantChangeEvent);

            // Update price display
            updatePriceDisplay(matchedVariant);

            // Update form submit button state
            const submitButton = productForm.querySelector('.mt-product-form__submit') ||
              productForm.querySelector('.product-form__submit') ||
              productForm.querySelector('button[type="submit"][name="add"]');
            if (submitButton) {
              submitButton.disabled = !matchedVariant.available;
              if (!matchedVariant.available) {
                const span = submitButton.querySelector('span');
                if (span) {
                  span.textContent = 'Sold Out';
                } else {
                  submitButton.textContent = 'Sold Out';
                }
              } else {
                const span = submitButton.querySelector('span');
                if (span) {
                  span.textContent = 'ADD TO CART';
                } else {
                  submitButton.textContent = 'ADD TO CART';
                }
              }
            }
          }
        });
      });
    });
  }

  // Update price display when variant changes
  function updatePriceDisplay(variant) {
    if (!variant) {
      return;
    }

    // Format price using Shopify's money format if available, otherwise use simple format
    function formatMoney(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents);
      }
      // Fallback: simple format
      const currency = window.Shopify?.currency?.active || 'USD';
      const symbol = currency === 'USD' ? '$' : currency;
      return symbol + (cents / 100).toFixed(2);
    }

    // Update all price boxes (mobile and desktop)
    const priceBoxes = document.querySelectorAll('.mt-price-box');

    if (priceBoxes.length === 0) {
      return;
    }

    priceBoxes.forEach(function (priceBox, index) {
      const currentPriceEl = priceBox.querySelector('.mt-price-item--current');
      const oldPriceEl = priceBox.querySelector('.mt-price-item--old');

      if (currentPriceEl) {
        const formattedPrice = formatMoney(variant.price);
        currentPriceEl.textContent = formattedPrice;
        // 强制触发重绘
        currentPriceEl.style.display = 'none';
        currentPriceEl.offsetHeight; // 触发重排
        currentPriceEl.style.display = '';
      }

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (!oldPriceEl) {
          const oldPrice = document.createElement('span');
          oldPrice.className = 'mt-price-item--old';
          priceBox.appendChild(oldPrice);
        }
        const oldPriceElement = priceBox.querySelector('.mt-price-item--old');
        if (oldPriceElement) {
          const formattedOldPrice = formatMoney(variant.compare_at_price);
          oldPriceElement.textContent = formattedOldPrice;
          oldPriceElement.style.display = 'inline';
        }
      } else {
        if (oldPriceEl) {
          oldPriceEl.style.display = 'none';
        }
      }
    });

    // 额外检查：查找页面上所有可能的价格元素
    const allPriceElements = document.querySelectorAll('.price, .mt-price-item--current, [data-product-price], .product__price');
    allPriceElements.forEach(function (el, idx) {
    });

  }

  // Listen to variant changes globally to update price
  function initVariantPriceUpdater() {

    // Method 1: Listen to variant:change event (Shopify standard)
    document.addEventListener('variant:change', function (event) {
      if (event.detail && event.detail.variant) {
        const variant = event.detail.variant;
        // 延迟更新，确保 Shopify 原生组件更新完成后再更新
        setTimeout(function () {
          updatePriceDisplay(variant);
        }, 50);
      }
    });

    // Method 2: Listen to variant ID input change event
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const variantIdInput = productForm.querySelector('input[name="id"]');
      if (variantIdInput) {
        variantIdInput.addEventListener('change', function () {
          const variantId = parseInt(this.value, 10);
          if (variantId) {
            // Try to get variant from window.productVariants
            const variants = window.productVariants || [];
            const variant = variants.find(function (v) {
              return v.id === variantId;
            });
            if (variant) {
              // 延迟更新，确保其他更新完成
              setTimeout(function () {
                updatePriceDisplay(variant);
              }, 50);
            }
          }
        });
      }

      // Method 3: Listen to variant picker changes (dropdowns, radio buttons)
      const variantPickers = productForm.querySelectorAll('[name^="option"], select[name^="option"], input[type="radio"][name^="option"]');
      variantPickers.forEach(function (picker) {
        picker.addEventListener('change', function () {
          // Wait a bit for the variant ID input to update
          setTimeout(function () {
            const variantIdInput = productForm.querySelector('input[name="id"]');
            if (variantIdInput && variantIdInput.value) {
              const variantId = parseInt(variantIdInput.value, 10);
              if (variantId) {
                const variants = window.productVariants || [];
                const variant = variants.find(function (v) {
                  return v.id === variantId;
                });

              }
            }
          }, 100);
        });
      });
    }
  }

  // Initialize variant price updater when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantPriceUpdater);
  } else {
    initVariantPriceUpdater();
  }

  // Initialize quantity selector
  function initQuantitySelector() {
    const quantityInputs = document.querySelectorAll('.quantity__input');

    quantityInputs.forEach(function (input) {
      const quantityWrapper = input.closest('.quantity');
      if (!quantityWrapper) return;

      const minusBtn = quantityWrapper.querySelector('.quantity__button[name="minus"]');
      const plusBtn = quantityWrapper.querySelector('.quantity__button[name="plus"]');
      const min = parseInt(input.getAttribute('min') || input.getAttribute('data-min') || '1', 10);
      const max = input.getAttribute('max') || input.getAttribute('data-max');

      // Minus button
      if (minusBtn) {
        minusBtn.addEventListener('click', function () {
          let value = parseInt(input.value, 10) || min;
          if (value > min) {
            value = value - parseInt(input.getAttribute('step') || '1', 10);
            if (value < min) value = min;
            input.value = value;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      // Plus button
      if (plusBtn) {
        plusBtn.addEventListener('click', function () {
          let value = parseInt(input.value, 10) || min;
          const step = parseInt(input.getAttribute('step') || '1', 10);
          value = value + step;
          if (max && value > parseInt(max, 10)) {
            value = parseInt(max, 10);
          }
          input.value = value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      // Validate input
      input.addEventListener('change', function () {
        let value = parseInt(input.value, 10) || min;
        if (value < min) value = min;
        if (max && value > parseInt(max, 10)) value = parseInt(max, 10);
        input.value = value;
      });

      input.addEventListener('blur', function () {
        let value = parseInt(input.value, 10) || min;
        if (value < min) value = min;
        if (max && value > parseInt(max, 10)) value = parseInt(max, 10);
        input.value = value;
      });
    });
  }
})();

// Buy Now Button Handler for Bundle Products (独立执行，不依赖 initBundleProducts)
(function () {
  'use strict';


  let isInitialized = false;
  let formSubmitHandler = null;
  let clickHandler = null;
  let mousedownHandler = null;

  // 等待 DOM 加载完成后再执行
  function initBuyNowHandler() {
    // 允许多次调用（Shopify payment button / 表单可能延迟渲染），通过 DOM 标志位避免重复绑定
    // isInitialized 仅用于标记“至少运行过一次”，不再作为硬阻断
    isInitialized = true;

    // Function to build cart items for buy now (独立版本)
    async function buildCartItemsForBuyNow(contextEl) {
      const items = [];

      function parsePositiveInt(value) {
        const n = parseInt(String(value || '').trim(), 10);
        return Number.isFinite(n) && n > 0 ? n : null;
      }

      function getMainForm() {
        // Prefer the form related to the clicked button/context element to avoid picking the wrong /cart/add form.
        if (contextEl) {
          const directForm = contextEl.closest && contextEl.closest('form');
          if (directForm) return directForm;

          const productInfo = contextEl.closest && contextEl.closest('[id^="ProductInfo-"]');
          if (productInfo) {
            const scoped =
              productInfo.querySelector('form[data-type="add-to-cart-form"]') ||
              productInfo.querySelector('form[action*="/cart/add"]') ||
              productInfo.querySelector('product-form form');
            if (scoped) return scoped;
          }
        }

        // Fallback: first match in document
        return (
          document.querySelector('form[data-type="add-to-cart-form"]') ||
          document.querySelector('form[action*="/cart/add"]') ||
          document.querySelector('product-form form') ||
          document.querySelector('form[action="/cart/add"]')
        );
      }

      function getMainVariantId() {
        const productForm = getMainForm();
        const idInput =
          (productForm && productForm.querySelector('input[name="id"]')) ||
          document.querySelector('input[name="id"]');
        const fromInput = idInput ? parsePositiveInt(idInput.value) : null;
        if (fromInput) return fromInput;

        // Fallback: some themes keep a master selector
        const masterSelect = document.querySelector('select[name="id"], select.product-form__variants');
        const fromSelect = masterSelect ? parsePositiveInt(masterSelect.value) : null;
        if (fromSelect) return fromSelect;

        // Fallback: variant in URL (?variant=)
        try {
          const url = new URL(window.location.href);
          const v = parsePositiveInt(url.searchParams.get('variant'));
          if (v) return v;
        } catch (e) { }

        return null;
      }

      function getMainQuantity() {
        const productForm = getMainForm();
        const qtyInput =
          (productForm && productForm.querySelector('input[name="quantity"]')) ||
          document.querySelector('input[name="quantity"]');
        const qty = qtyInput ? parsePositiveInt(qtyInput.value) : 1;
        return qty || 1;
      }

      // Always include main product if we can resolve a valid variant id
      const mainVariantId = getMainVariantId();
      if (mainVariantId) {
        items.push({ id: mainVariantId, quantity: getMainQuantity() });
      }

      function extractBundleItemFromCard(card) {
        if (!card) return null;
        if (card.getAttribute('data-disabled') === 'true' || card.classList.contains('disabled')) return null;

        const variantId = parsePositiveInt(card.getAttribute('data-variant-id') || card.dataset.variantId);
        if (!variantId) return null;

        const qtyInput = card.querySelector('.mt-bundle-qty');
        const qty = qtyInput ? parsePositiveInt(qtyInput.value) : 1;
        return { id: variantId, quantity: qty || 1 };
      }

      // 1) Primary source: selected cards in DOM
      const selectedBundleCards = Array.from(document.querySelectorAll('.mt-bundle-product-card.selected'));
      selectedBundleCards.forEach(function (card) {
        const item = extractBundleItemFromCard(card);
        if (item) items.push(item);
      });

      // NOTE: 不做 “全局 Set 回退”。
      // 原因：这些集合容易残留历史点击，导致结账带上错误的捆绑商品（你遇到的“只剩第二个捆绑商品”）。
      // 这里严格以 DOM 当前 `.mt-bundle-product-card.selected` 为准：未选中就不加捆绑。

      // Merge duplicates by variant id
      const merged = {};
      items.forEach(function (item) {
        if (!item || !item.id) return;
        if (!merged[item.id]) merged[item.id] = { id: item.id, quantity: 0 };
        merged[item.id].quantity += Number(item.quantity || 1);
      });

      const finalItems = Object.keys(merged).map(function (key) {
        return merged[key];
      });

      // If main product couldn't be resolved, DO NOT proceed silently (prevents checkout with only 1 bundle item)
      // Return empty to let callers fall back to native flow, or do nothing.
      if (!mainVariantId) {
        // If there are bundle items but main is missing, it's safer to abort than create wrong checkout.
        return [];
      }

      return finalItems;
    }

    // Convert variant ID to Shopify GID format
    function toGID(id) {
      return 'gid://shopify/ProductVariant/' + Number(id);
    }

    // Create cart using Storefront API
    async function storefrontCartCreate(lines, token) {
      const query = `
      mutation CartCreate($lines: [CartLineInput!]!) {
        cartCreate(input: { 
          lines: $lines
        }) {
          cart { checkoutUrl }
          userErrors { message }
        }
      }
    `;

      const res = await fetch('/api/2024-07/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({ query: query, variables: { lines: lines } })
      });

      const json = await res.json();

      const url = json && json.data && json.data.cartCreate && json.data.cartCreate.cart && json.data.cartCreate.cart.checkoutUrl;
      const err = (json && json.errors && json.errors[0] && json.errors[0].message) ||
        (json && json.data && json.data.cartCreate && json.data.cartCreate.userErrors && json.data.cartCreate.userErrors[0] && json.data.cartCreate.userErrors[0].message) ||
        ('HTTP ' + res.status);

      if (!url) {
        throw new Error(err || 'cartCreate failed');
      }

      return url;
    }

    // mt-now-buy2 同款写法：直接绑定到真实按钮元素 + MutationObserver 兜底（更稳定）
    function getStorefrontToken() {
      return (
        window.__SF_TOKEN__ ||
        (window.Shopify && window.Shopify.settings && window.Shopify.settings.storefrontToken) ||
        (function () {
          const scriptTag = document.querySelector('script[data-storefront-token]');
          return scriptTag ? scriptTag.getAttribute('data-storefront-token') : null;
        })()
      );
    }

    async function handleBuyNowClick(e, btn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const token = getStorefrontToken();
      if (!token) return;

      // Wait a tick in case theme scripts update the hidden variant input on click.
      await new Promise(function (r) { setTimeout(r, 0); });

      const items = await buildCartItemsForBuyNow(btn);
      // 拿不到主商品 variantId 时 buildCartItemsForBuyNow 会返回 []，此时直接中止，避免错误结账
      if (!items.length) return;

      const lines = items.map(function (it) {
        return { quantity: Number(it.quantity || 1), merchandiseId: toGID(it.id) };
      });

      // Prevent double-submit, but don't permanently lock the button if navigation doesn't happen.
      const restoreButton = function () {
        if (!btn) return;
        if (btn.disabled !== undefined) {
          btn.disabled = false;
        } else {
          btn.style.pointerEvents = 'auto';
          btn.style.opacity = '1';
        }
      };

      if (btn) {
        if (btn.disabled !== undefined) {
          btn.disabled = true;
        } else {
          btn.style.pointerEvents = 'none';
          btn.style.opacity = '0.5';
        }
      }

      // Fallback: re-enable after a few seconds if we're still on the same page (e.g. blocked navigation)
      const reenableTimer = setTimeout(function () {
        restoreButton();
      }, 500);

      // Also restore on visibility/page hide transitions (back navigation / aborted redirects)
      const onVis = function () {
        if (!document.hidden) restoreButton();
      };
      document.addEventListener('visibilitychange', onVis, { passive: true, once: true });

      try {
        const checkoutUrl = await storefrontCartCreate(lines, token);
        window.location.href = checkoutUrl;
      } catch (err) {
        restoreButton();
      } finally {
        clearTimeout(reenableTimer);
        // If redirect doesn't occur, restore shortly after request settles.
        setTimeout(function () {
          restoreButton();
        }, 300);
      }
    }

    function setupBuyNowElementListener(btn) {
      if (!btn) return;
      if (btn.hasAttribute('data-mt-buynow-handler-attached')) return;
      btn.setAttribute('data-mt-buynow-handler-attached', 'true');
      btn.addEventListener(
        'click',
        function (e) {
          handleBuyNowClick(e, btn);
        },
        { passive: false, capture: true },
      );
    }

    function bindAllBuyNowButtons() {
      const buttons = document.querySelectorAll(
        '.shopify-payment-button__button, .shopify-payment-button__button--branded, .shopify-payment-button__button--unbranded, shop-pay-wallet-button, SHOP-PAY-WALLET-BUTTON',
      );
      buttons.forEach(function (btn) {
        setupBuyNowElementListener(btn);
      });
    }

    bindAllBuyNowButtons();

    if (!document.documentElement.hasAttribute('data-mt-buynow-observer')) {
      document.documentElement.setAttribute('data-mt-buynow-observer', 'true');
      const observer = new MutationObserver(function () {
        bindAllBuyNowButtons();
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  // 在 DOM 加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initBuyNowHandler();
    });
  } else {
    // DOM 已经加载完成，立即执行
    initBuyNowHandler();
  }

  // 也延迟执行一次，确保 Shopify payment button 已经加载
  setTimeout(function () {
    initBuyNowHandler();
  }, 500);

  setTimeout(function () {
    initBuyNowHandler();
  }, 500);

  // 添加初始日志
})();
